{
  "login": "Entrar",
  "user": "Usuário",
  "password": "Senha",
  "enter": "ENTRAR",
  "recover": "Recuperar credenciais",
  "gauth_title": "Verificação em duas etapas",
  "gauth_enrollment_subtitle": "Seu papel exige autenticação em duas etapas. Configure-a uma única vez.",
  "gauth_scan_instruction": "Escaneie o código com o Google Authenticator e digite o código de 6 dígitos.",
  "gauth_code_label": "Digite o código de 6 dígitos do seu aplicativo de autenticação.",
  "gauth_invalid_code": "O código é inválido ou expirou.",
  "info_card": "Para suporte sobre o aplicativo SmartEco, por favor envie um email para",
  "user_not_valid": "Por favor, insira um usuário válido!",
  "user_password_valid": "Por favor, insira uma senha válida",
  "password_size": "A senha deve ter pelo menos 12 caracteres",
  "recovery_options": "Opções de recuperação",
  "form": "Formulário",
  "recover_user": "Recuperar usuário",
  "recover_password": "Recuperar senha",
  "cancel": "Cancelar",
  "label_email": "E-mail",
  "send_email": "Enviar email",
  "generic_recovery_message": "Se existir uma conta associada, você receberá instruções por e-mail.",
  "recover_password_capital_letter": "RECUPERAR SENHA",
  "name_user_capital_letter": "Nome de usuário",
  "field_required": "Este campo é obrigatório",
  "new_password_capital_letter": "NOVA SENHA",
  "recover_password_text": "Lembre-se de que a senha deve ter pelo menos 12 caracteres",
  "very_weak": "Muito fraca",
  "weak": "Fraca",
  "good": "Boa",
  "strong": "Forte",
  "verificate_password_capital_letter": "VERIFICAR SENHA",
  "update_password": "Atualizar senha",
  "all_rights_reserved": "Todos os direitos reservados",
  "version": "versão",
  "updatePassword": "Senha atualizada",
  "error_message1": "Ops, ocorreu um problema",
  "auth_security_validation_unavailable": "Não foi possível validar a segurança da solicitação. Tente novamente.",
  "auth_recovery_generic_message": "Se as informações forem válidas, você receberá instruções por e-mail.",
  "auth_recovery_error_message": "Não foi possível processar a solicitação. Por favor, tente novamente mais tarde.",
  "auth_cooldown_message": "Muitas tentativas. Tente novamente em {{seconds}}s.",
  "equal_fields": "Os campos devem coincidir",
  "shortcut": "ATALHOS",
  "msgIdiom": "Idioma alterado com sucesso",
  "language": "Idioma",
  "spanish": "Espanhol",
  "english": "Inglês",
  "Portuguese": "Português",
  "SignOff": "Sair",
  "export_data": "Exportar dados",
  "management": "GERENCIAMENTO",
  "pane": "painel de ferramentas",
  "viewShortcuts": "Ver atalhos de teclado",
  "closeShortcuts": "Fechar atalhos de teclado",
  "beginning": "Início",
  "updateTable": "Atualizar tabela",
  "point": "Pontos",
  "account": "Contas",
  "groups": "Grupos",
  "domains": "Domínios",
  "doamin": "Domínio",
  "rates": "Cotações",
  "transactions": "Transações",
  "serviceProvider": "Prestador de serviços",
  "entities": "Entidades",
  "paymentMethods": "Métodos de pagamento",
  "money": "Dinheiro",
  "ResourceSources": "Fontes de recursos",
  "budget": "Orçamento",
  "bill": "Fatura",
  "Payments": "Pagamentos",
  "audits": "Auditorias",
  "loads": "Cargas",
  "meter": "Medidor",
  "search": "Procurar",
  "reportDownloads": "Downloads de relatórios",
  "company": "Empresa",
  "roles": "Funções",
  "invoiceDashboard": "Dashboard de faturas",
  "dashboardPayments ": "Dashboard de pagamentos",
  "Vertebots": "Vertebots",
  "serviceProviders": "Provedores de serviços",
  "concepts": "Conceitos",
  "name": "Nome",
  "copy": "Copiar",
  "copied": "Copiado",
  "abbreviation": "Abreviação",
  "abb": "Abrev",
  "type": "Tipo",
  "inverter": "Inversor",
  "identificationBusiness": "NIT",
  "dv": "DV",
  "service": "Serviços",
  "movii": "Movii",
  "voucher": "Comprovante",
  "email": "email",
  "yes": "Sim",
  "no": "Não",
  "delete": "Excluir",
  "edit": "Editar",
  "create": "Criar",
  "searchs": "Pesquisar",
  "state": "Estado",
  "activate": "Ativar",
  "deactivate": "Desativar",
  "activeTable": "Ativo",
  "inactive": "Inativo",
  "subproject": "Subprojeto",
  "extras": "Extras",
  "seeExtras": "Ver extras",
  "extrasOf": "EXTRAS DE ",
  "addEquivalence": "Adicionar equivalência",
  "department": "Departamento",
  "city": "Cidade",
  "dateFirst": "Data de início",
  "dateEnd": "Data final",
  "total": "Total",
  "record": "Registros",
  "detail": "Detalhe",
  "remember": "Lembrar",
  "textAlertProvider": "Para poder administrar as notificações, a conta deve ser editada e selecionar a opção de multi notificação.",
  "deleteTextAlertProvider": "O provedor de serviço foi excluído com sucesso.",
  "upateTextAlertProvider": "Provedor de serviço atualizado para:",
  "updateNotificationProviderActivate": "Envio de notificações ativado",
  "updateNotificationProviderDesactivate": "Envio de notificações desativado",
  "manageNotifications": "Gerenciar notificações",
  "activatePetitionBill": "Ativar envio de petição de fatura",
  "deactivatePetitionBill": "Desativar envio de petição de fatura",
  "viewProviderInformation": "Ver informações do provedor",
  "close": "Fechar",
  "short": "Curto",
  "multiNotification": "MULTI NOTIFICAÇÃO",
  "phone": "Telefone",
  "fieldRequiredNumber": "Este campo aceita apenas números",
  "fieldRequiredDv": "Deve digitar o número de digitação",
  "fielRequiredType": "Deve selecionar um tipo",
  "typeService": "Tipo de Serviço",
  "fieldRequiredTypeService": "Deve selecionar o tipo de serviço",
  "proffSeding": "ENVIO DE COMPROVANTE",
  "fieldRequiredOption": "Deve selecionar uma opção",
  "notificationEmail": "Notificação por e-mail",
  "regularPayment": "PAGAMENTO REGULAR",
  "regulatedPayment": "Pagamento regulado",
  "reactiveCharge": "Cobrança por reativa",
  "fieldNitRequired": "Deve digitar um NIT",
  "alertEntityDelete": "A entidade foi excluída com sucesso.",
  "nameEntity": "Nome da entidade",
  "stateEnity": "Estado da entidade",
  "notificationDeleteDomains": "O domínio foi excluído com sucesso.",
  "father": "Pai",
  "dNotHave": "Não possui",
  "domainCreate": "Domínio criado",
  "alertDomainCreate": "Seu domínio foi criado com sucesso",
  "selectionFather": "Deve selecionar um pai",
  "add": "Adicionar",
  "removeFather": "remover pai",
  "alertPaymentDelete": "O método de pagamento foi excluído com sucesso.",
  "addEquivalenceA": "Adicionar equivalência a",
  "updateConcept": "Editar conceito",
  "alertDeleteMeter": "Tem certeza de que deseja excluir este medidor:",
  "deleteMeter": "Medidor excluído com sucesso",
  "updateMeters": "Medidor modificado com sucesso",
  "addMeterNews": "Medidor criado com sucesso",
  "subprojects": "Subprojetos",
  "disableSubProjectText": "Desabilitar subprojetos caso não se aplique ao tipo de serviço",
  "deleteTarFeeAlert": "Tem certeza de que deseja excluir esta tarifa?",
  "alertDeleteFee": "Tarifa excluída com sucesso",
  "createRate": "Criar tarifa",
  "updateRate": "Editar tarifa",
  "viewFiles": "Ver Arquivo",
  "noFiles": "Sem arquivos",
  "voltageLevel": "Nível de tensão",
  "propiety": "Propriedade",
  "detailOf": "Detalhe de",
  "recolection": "Coleta",
  "publicToilet": "Banheiro público",
  "complementary": "Complementar",
  "sumptuary": "Sumptuário",
  "energeticValue": "Valor Energético",
  "deleteUserQuestion": "Tem certeza de que deseja excluir este usuário?",
  "deleteUserAlert": "Usuário excluído com sucesso",
  "updateUserQuestion": "Tem certeza de que deseja alterar o estado deste usuário?",
  "updateUserAlert": "Estado do usuário modificado",
  "nickName": "Apelido",
  "lastAdmission": "Último ingresso",
  "verified": "Verificado",
  "notVerified": "Verificação pendente pelo usuário",
  "updateState": "Alterar estado",
  "assign": "Atribuir",
  "access": "Acessos",
  "office": "Escritórios",
  "notification": "Notificações",
  "download": "Baixar",
  "accessUpdatedAlert": "Acessos atualizados com sucesso",
  "group": "Grupo",
  "result": "Resultado",
  "userAccessRepeat": "Este usuário já possui todos os grupos atribuídos",
  "Ops": "Ops",
  "valueRequired": "Este valor é obrigatório",
  "regionals": "Regionais",
  "typeUser": "Tipo de usuário",
  "allRegionals": "Todas as regionais",
  "selectionAll": "Selecionar tudo",
  "deleteAssign": "Excluir atribuições",
  "textUserAssgin": "Para continuar, selecione uma empresa",
  "assignReportBi": "Atribuir Relatórios de BI",
  "report": "Relatórios",
  "all": "Todos",
  "url": "URL",
  "reportDownload": "Download de Relatórios",
  "assignReportDownload": "Atribuição de download de relatórios",
  "alertOfficeRegister": "Escritórios registrados com sucesso",
  "permissions": "Permissões",
  "removed": "Removida",
  "saveChanges": "Salve para salvar as alterações.",
  "save": "Salvar",
  "alertMessageNotifications": "Todas as notificações serão desativadas.",
  "alertConfigNotifications": "Configurações de notificações atualizadas",
  "configNotification": "Configurar notificações",
  "activateConfirm": "Ativada",
  "deactivateConfirm": "Desativada",
  "messageNotifications": "Todas as notificações da empresa foram desativadas",
  "notificationBillCompany": "Notificar se a fatura da empresa",
  "wasLoaded": "foi carregada.",
  "notificationVoucherCompany": "Notificar se o comprovante de pagamento da empresa",
  "itRejected": "foi rejeitada.",
  "notifyIf": "Notificar se",
  "billAndVouchers": "carregar fatura e/ou comprovantes.",
  "addRolSave": "O papel já foi adicionado para esta empresa",
  "userSaveUpdated": "Usuário atualizado com sucesso",
  "userGetInto": "Por favor, insira um nome!",
  "lastName": "Sobrenome",
  "lastNameUsergetInto": "Por favor, insira um sobrenome!",
  "emailError": "Por favor, insira um e-mail válido!",
  "rolAplication": "Função do aplicativo",
  "assignRolCompany": "Atribuir funções por empresa",
  "generatePassword": "Gerar senha",
  "pleasePassworValidate": "Por favor, insira uma senha válida!",
  "users": "Usuários",
  "rolDeleteAlert": "Tem certeza de que deseja excluir este papel?",
  "rolDeleteAlertConfirm": "Papel excluído com sucesso",
  "updateRolAlert": "Tem certeza de que deseja alterar o estado deste papel?",
  "updateRolAlerModif": "Estado do papel modificado",
  "cancelAlert": "Cancelada",
  "actionUpdateCancel": "Ação de mudança de estado cancelada",
  "rolModif": "Papel modificado com sucesso",
  "createRol": "Papel criado com sucesso",
  "pointDeleteAlert": "O ponto foi excluído com sucesso.",
  "notVerificed": "",
  "admiPoint": "Administrar ponto",
  "viewInfoPoint": "Ver informações do ponto",
  "viewHistoryPoint": "Ver histórico de pontos",
  "generateCertificed": "Gerar certificado",
  "order": "Ordem",
  "direction": "Direção",
  "others": "Outros",
  "location": "Localização",
  "power": "Potência",
  "amount": "Quantidade",
  "noData": "Sem dados",
  "enterPointName": "Você deve digitar um nome do ponto",
  "namePoint": "Nome do ponto",
  "fullName": "Nome completo",
  "enterCityName": "Você deve digitar o nome da cidade",
  "enterDptoName": "Você deve digitar o departamento",
  "enterLocationName": "Você deve digitar um endereço",
  "paymentNotification": "Notificação de pagamento",
  "sendNotificationPayment": "Enviar notificação de pagamento ao pagamento",
  "pointState": "Estado do ponto",
  "officeCode": "Código do escritório",
  "entrerCodOffice": "Você deve digitar o código do escritório",
  "numberEmployer": "Nº de funcionários",
  "area": "Área",
  "latitude": "Latitude",
  "fielObligatoryLatitude": "Este campo é obrigatório se você inserir uma longitude",
  "length": "Longitude",
  "fieldObligatoryLength": "Este campo é obrigatório se você inserir uma latitude",
  "namePonitShort": "Você deve digitar um nome curto do ponto",
  "updateStateExit": "O estado da conta foi alterado com sucesso",
  "dateFirstOperation": "Data de início de operação",
  "dateSelection": "Você deve selecionar uma data",
  "dateUpdateText": "Data de atualização do estado",
  "infoPoint": "Informações do ponto",
  "employer": "Empregados",
  "codOffice": "Código do escritório",
  "allowsNotifications": "Permite notificações",
  "update": "Alterar",
  "shedule": "Horários",
  "enterDate": "Insira uma data",
  "enterDateEnd": "Insira uma data final",
  "accountDelete": "A conta foi excluída com sucesso.",
  "editAuthorizations": "Editar autorizações",
  "UploadArchive": "Enviar arquivo plano",
  "addNovelty": "Adicionar novidade",
  "viewNovelty": "Ver",
  "viewInfoAccount": "Ver informações da conta",
  "viewHistoryAcoount": "Ver histórico de contas",
  "number": "Número",
  "dates": "Datas",
  "Cleanliness": "Limpeza",
  "Gas": "Gás",
  "water": "Água",
  "enegy": "Energia",
  "sewerage": "Esgoto",
  "streetLighting": "Iluminação pública",
  "novelty": "Novidades",
  "authorized": "Autorizado",
  "paymentInfoCompleted": "Info. de pagamento completa",
  "newComercio": "Nova comerciante desde",
  "previusAccount": "Conta anterior",
  "inactiveSince": "Inativo desde",
  "authorizedPayment": "Pagamento autorizado",
  "dataAccount": "Dados da conta",
  "codVerification": "Código de verificação",
  "enterNumberAccount": "Deve inserir um número de conta",
  "numberMeter": "Número do medidor",
  "emailNotification": "Notificação por e-mail",
  "markertType": "Tipo de mercado",
  "infoLocation": "Informação de localização",
  "selectionRegional": "Deve selecionar a regional",
  "selectionPoint": "Deve selecionar um ponto",
  "selectionService": "Deve selecionar o provedor de serviço",
  "dateEmition": "Data de emissão",
  "dateStimedPayment": "Data estimada de pagamento",
  "timelyPaymentDate": "Data de pagamento oportuno",
  "initialBillingDate": "Data inicial de faturamento",
  "dateInitial": "Data inicial",
  "BudgetsAndPayments": "Orçamentos e pagamentos",
  "frequency": "Frequência",
  "accountFather": "Conta pai",
  "socioeconomicLevel": "Nível socioeconômico",
  "paymentVertebra": "Pagamento de vértebra",
  "authorizedForPayment": "Autorizado para pagamento",
  "clientUploadBill": "Cliente faz o upload da fatura",
  "serviceDate": "Datas do serviço",
  "StreetLighting": "Iluminação pública",
  "selectionFrecuency": "Deve selecionar a frequência",
  "uploadFileOk": "Upload do arquivo plano realizado com sucesso",
  "dateBill": "Data da fatura",
  "dateReal": "Data real",
  "billingPeriod": "Período de faturamento",
  "dateBillDate": "Data da fatura",
  "suspencionDate": "Data de suspensão",
  "period": "Período",
  "upSupport": "Enviar suporte",
  "fieldRequired": "Campo obrigatório!",
  "clickUploadVoucher": "Clique ou arraste o comprovante",
  "uploadFile": "Enviar arquivo",
  "changeOfMarketer": "Mudança de comerciante",
  "numberAccount": "Número da conta",
  "estimatedDateOFIssue": "Data estimada de emissão",
  "tymelyPaymentDate": "Data de pagamento oportuno",
  "infoPaymentVertebra": "Informações de pagamento de vértebra",
  "allowPayment": "Permitir pagamento",
  "typeNovelty": "Tipo de novidade",
  "comentary": "Comentário",
  "observation": "Observação",
  "comentaryNovelty": "Comentário da novidade",
  "newNovelty": "Criar novidade",
  "shortName": "Nome curto",
  "allowPaymentNotificatios": "Permitir notificações de pagamento",
  "inactivationDate": "Data de inativação",
  "propertyLevel": "Nível de propriedade",
  "coordinates": "Coordenadas",
  "dateOfIssue": "Data de emissão",
  "numberVerification": "Número de verificação",
  "serviceName": "Nome do serviço",
  "lastBill": "Última fatura",
  "selectRecordTheChange": "Selecione um registro para ver as alterações",
  "export": "Exportar",
  "userMakingtheChange": "Usuário que fez a alteração",
  "operationDate": "Data da operação",
  "alertDeleteRates": "Tem certeza de que deseja excluir esta tarifa?",
  "rateDeleteOk": "Tarifa excluída com sucesso",
  "closeNovelty": "Fechar novidade",
  "addComentary": "Adicionar comentário",
  "deleteGroupAlert": "Grupo excluído com sucesso",
  "groupCode": "Código do grupo",
  "groupName": "Nome do grupo",
  "errorNameRegional": "Deve inserir um nome de regional",
  "selectionStateError": "Deve selecionar um estado",
  "stateGroup": "Estado do grupo",
  "transaction": "Transações",
  "resourceSource": "Origem de recurso",
  "BillToPay": "Contas a pagar",
  "newTransaction": "Criar transação",
  "closeTransaction": "Fechar transação",
  "concilationsView": "Ver conciliações",
  "uploadFileConcilation": "Enviar arquivo de conciliação",
  "operationType": "Tipo de operação",
  "bankVerification": "Verificação bancária",
  "menu": "Menu",
  "transactionVerified": "Transação verificada",
  "amounts": "Montantes",
  "initialBalance": "Saldo inicial",
  "endBalance": "Saldo final",
  "responsible": "Responsável",
  "reconcile": "Conciliar",
  "viewInfoBill": "Ver informações da fatura",
  "detailBill": "Detalhe da fatura",
  "noveltyDeleteOk": "Novidade excluída com sucesso",
  "comentaryDeleteOk": "Comentário excluído com sucesso",
  "sourceIdResource": "ID da origem do recurso",
  "sourceNameOfTheresource": "Nome da origem do recurso",
  "sourceIdCompany": "ID da origem da empresa",
  "sourceNameOfTheCompany": "Nome da origem da empresa",
  "place": "Local",
  "contactAccount": "Conta de contato",
  "marketer": "Comerciante",
  "numberBill": "Número da fatura",
  "typeRegister": "Tipo de registro",
  "totalToPay": "Total a pagar",
  "paymentMade": "Pagamento efetuado",
  "dateOfBills": "Data da fatura",
  "dateSuspencion": "Data de suspensão",
  "paymentDate": "Data de pagamento",
  "viewBill": "Ver fatura",
  "updateCompany": "Empresa atualizada com sucesso",
  "updateQuuestionCompany": "Tem certeza de que deseja alterar o estado desta empresa?",
  "stateCompanyAlert": "Estado da empresa alterado",
  "assignNotification": "Atribuir notificações",
  "newCompany": "Criar empresa",
  "editCompany": "Editar empresa",
  "manager": "Gerente",
  "change": "Alterar",
  "updateTransaction": "Editar transação",
  "reconciliations": "Conciliações",
  "manualReconciliations": "Conciliações manuais",
  "originOfMoney": "Origem do dinheiro",
  "paymentMethod": "Método de pagamento",
  "paymentReference": "Referência de pagamento",
  "valuePaid": "Valor pago",
  "voucherNumber": "Número do comprovante",
  "enablePaymentVertebra": "Habilitado para pagamento vertebral",
  "enableForPayment": "Habilitado para pagamento",
  "seeProof": "Ver comprovante",
  "creation": "Criação",
  "billLoad": "Carregamento da fatura",
  "typedBy": "Digitado por",
  "approvedBy": "Aprovado por",
  "voucherUpload": "Carregamento do comprovante",
  "conceptsForConsumption": "Conceitos para consumo",
  "toiletPrice": "Preço do banheiro",
  "contributionForTheToilet": "Contribuição para o banheiro",
  "totalPaidInToilet": "Total pago no banheiro",
  "activeEnergyCurrentMeasurement": "Medição atual de energia ativa",
  "previusEnergyCurrentMeasurement": "Medição anterior de energia ativa",
  "activePowerEnergy": "Fator de energia ativa",
  "activeEnergyConsumption": "Consumo de energia ativa",
  "activeEnergyRate": "Taxa de energia ativa",
  "activeEnergyPrice": "Preço da energia ativa",
  "activeEnergyContribution": "Contribuição de energia ativa",
  "currentMesurementOrReactiveEnergy": "Medição atual de energia reativa",
  "previusMesurementOrReactiveEnergy": "Medição anterior de energia reativa",
  "reactivePowerfactor": "Fator de energia reativa",
  "reactiveEnergyComsuption": "Consumo de energia reativa",
  "reactiveEnergyrate": "Taxa de energia reativa",
  "reactiveEnergiPrice": "Preço da energia reativa",
  "contributionForReactiveEnergy": "Contribuição para energia reativa",
  "hourOfInterruption": "Horas de interrupção",
  "totalPaidEnergy": "Total pago de energia",
  "currentMeasureOfAqueduct": "Medição atual do aqueduto",
  "previusMeasureOfAqueduct": "Medição anterior do aqueduto",
  "waterComsuption": "Consumo de água",
  "basicAqueductRate": "Taxa básica de aqueduto",
  "coplementaryAqueductRate": "Taxa complementar de aqueduto",
  "suntaryAqueductRate": "Taxa de aqueduto voluntário",
  "basicFixedPriceAqueduct": "Preço fixo básico do aqueduto",
  "complementaryFixedPriceAqueduct": "Preço fixo complementar do aqueduto",
  "fixedPriceQueduct": "Preço fixo do aqueduto",
  "aqueductContribution": "Contribuição do aqueduto",
  "contributionForAqueductFixedPrice": "Contribuição para o preço fixo do aqueduto",
  "basicSewerRate": "Taxa básica de esgoto",
  "sumpturySewerRate": "Taxa sumptuária de esgoto",
  "basicFIxedPriceAqueduct": "Preço fixo básico do aqueduto",
  "coplementarySewerRate": "Taxa complementar de esgoto",
  "coplementaryFixedPriceAqueduct": "Preço fixo complementar do aqueduto",
  "fixedPriceSumptaryAqueduct": "Preço fixo sumptuário do aqueduto",
  "seweragePrice": "Preço do esgoto",
  "fixedPriceAqueduct": "Preço fixo do aqueduto",
  "fixedPriceSewerage": "Preço fixo do esgoto",
  "contributionForSewerage": "Contribuição para esgoto",
  "contributionForFixedSeweragePrice": "Contribuição para o preço fixo do esgoto",
  "pricePaidForTheAqueductP": "Preço pago pelo aqueduto",
  "pricePaidForTheAqueduct": "Preço pago pelo aqueduto",
  "totalOther": "Total de outros",
  "voluntaryContribution": "Contribuição voluntária",
  "otherToilet": "Outros banheiros",
  "observations": "Observações",
  "noComment": "Sem comentários",
  "deleteComentaryAlertBill": "Você está prestes a excluir um comentário da fatura",
  "notComentary": "Sem comentários",
  "deleteNoveltyBillAlert": "Você está prestes a excluir uma novidade da fatura",
  "notNovelty": "Sem novidades",
  "tracing": "Rastreamento",
  "by": "por",
  "at": "às",
  "sorceId": "ID de Origem",
  "source": "Origem",
  "destinityID": "ID de Destino",
  "destinity": "Destino",
  "date": "Data",
  "reference": "Referência",
  "transferAmount": "Valor transferido",
  "resource": "Recurso",
  "transactionInfo": "Informações da transação",
  "refrenceInfo": "Informações de referência",
  "operationBillAsiigned": "A operação não possui uma fatura atribuída.",
  "paymentInfo": "Informações de pagamento",
  "auditInfo": "Informações de auditoria",
  "notNoveltyAdd": "Nenhuma novidade adicionada",
  "notConceptsAdd": "Nenhum conceito adicionado",
  "selectionDate": "Você deve selecionar uma data",
  "transactioExits": "A transação foi concluída com sucesso",
  "startDateOperation": "Data de início da operação",
  "errorFileUpload": "Erro no carregamento do arquivo.",
  "imageSizeErr": "a imagem não deve ter mais de 20 MB",
  "transactionEditOk": "Transação editada com sucesso",
  "transactionNewOk": "Transação criada com sucesso",
  "nameOperation": "Nome da operação",
  "numberBillEnter": "Digite o número da fatura",
  "numberReferencia": "Número de referência",
  "lockedReturn": "Bloquear retorno",
  "selectionRatesFile": "Clique ou arraste o comprovante da transação",
  "uploadVaucher": "Carregar comprovantes",
  "uploadFileBIll": "Você deve enviar uma imagem da fatura",
  "editRates": "Editar transações",
  "newRates": "Criar transação",
  "returnRates": "Retornar transação",
  "fileUploadOk": "Arquivo carregado com sucesso",
  "uploadReconciliation": "Carregar conciliação",
  "reportNewOk": "Relatório criado com sucesso",
  "yourReporNewOk": "Seu relatório foi criado com sucesso",
  "manualReconciliation": "Conciliação manual",
  "recolitianOk": "Conciliação realizada com sucesso",
  "totallySelection": "Total selecionado",
  "reconconciliationManully": "Realizar conciliação manual",
  "successConsoliditedOperation": "Operação consolidada com sucesso",
  "send": "Enviar",
  "addFounds": "Adicionar fundos",
  "editFounds": "Editar fundos",
  "updateQuestion": "Tem certeza de que deseja alterar o estado?",
  "stateResourseOrigen": "Estado da origem do recurso",
  "balance": "Saldo",
  "incomeMonth": "Receita do mês",
  "expensesMonth": "Despesas do mês",
  "seeDetails": "Ver detalhes",
  "viewBalanceHistory": "Ver histórico de saldos",
  "foundAddSuccefully": "Fundo adicionado com sucesso",
  "balances": "Saldos",
  "uploadProof": "Enviar comprovantes",
  "proodUploadFile": "Clique ou arraste o comprovante da transação",
  "detailRates": "Detalhes de uma transação",
  "lastClosing": "Último fechamento",
  "newResourceSource": "Criar origem do recurso",
  "editResourceSource": "Editar origem do recurso",
  "moveFounds": "Mover fundos",
  "resourceWithoutNumber": "Origem do recurso sem número",
  "toAccept": "Aceitar",
  "deleteResourceSourceAlert": "Tem certeza de que deseja excluir esta origem de recurso?",
  "resourceSourceDeleteOk": "Origem de recurso excluída com sucesso",
  "styateResourceSourceUpdate": "Estado da origem do recurso alterado com sucesso",
  "assignResourceSource": "Atribuir origem de recurso",
  "pricipally": "Principal",
  "children": "Filhos",
  "income": "Receitas",
  "expenses": "Despesas",
  "alert": "Alertas",
  "entitie": "Entidade",
  "assignAccess": "Atribuir Acessos",
  "sourceResourceOk": "Origem do recurso criada com sucesso",
  "resourceHierachy": "Hierarquia do recurso",
  "foundTransfer": "Transferência de fundos realizada com sucesso",
  "originResource": "Origem do recurso",
  "transactionDetail": "Detalhes da transação",
  "region": "Região",
  "reg": "Reg",
  "janury": "Janeiro",
  "jan": "Jan",
  "febraury": "Fevereiro",
  "feb": "Fev",
  "march": "Março",
  "mar": "Mar",
  "april": "Abril",
  "apr": "Abr",
  "May": "Maio",
  "mays": "Mai",
  "june": "Junho",
  "july": "Julho",
  "jun": "Jun",
  "jul": "Jul",
  "august": "Agosto",
  "aug": "Ago",
  "september": "Setembro",
  "sep": "Set",
  "october": "Outubro",
  "oct": "Out",
  "november": "Novembro",
  "nov": "Nov",
  "december": "Dezembro",
  "dec": "Dez",
  "general": "Geral",
  "gas": "Gás",
  "admin": "Admin",
  "tFija": "T. Fixa",
  "tMovil": "T. Móvel",
  "tv": "Televisão",
  "stateAccount": "Estado da conta",
  "supplier": "Fornecedor",
  "restoreInvoice": "Restaurar fatura",
  "seeInvoiceAndReceipt": "Ver fatura e recibos",
  "uploadfBill": "Carregar fatura",
  "unpaidInvoiceForVertebra": "Fatura não paga pela Vértebra",
  "NotDataViews": "Não há dados para mostrar",
  "accountPointBlock": "Conta ou ponto bloqueados",
  "retoreInvoicePeding": "Restaurar fatura pendente",
  "restore": "Restaurar",
  "support": "Suporte",
  "forPayment": "Para pagamento",
  "tracklingUpdateOk": "Rastreamento atualizado com sucesso",
  "noveltyPayment": "Novidades de pagamentos",
  "follows": "Seguimentos",
  "yourRemoveBillFollow": "Você está prestes a remover um acompanhamento da fatura",
  "revised": "Revisada",
  "revisedAccount": "Conta revisada",
  "billUpdatedAlertPunding": "Tem certeza de que deseja restaurar esta fatura para PENDENTE?",
  "areYouSure": "Você tem certeza?",
  "billUpdateAlertFingered": "Você está prestes a alterar o estado da sua fatura para DIGITADA",
  "paymentNotAuthorized": "Pagamento não autorizado",
  "month": "Mês",
  "editDateAssing": "Editar data atribuída",
  "statePaynment": "Estado de pagamento",
  "plataformNotRegister": "Não registrado na plataforma",
  "stateFingered": "Estado em digitação",
  "companyes": "Empresas",
  "statics": "Estatísticas",
  "rejectBillAlert": "Tem certeza de que deseja restaurar a fatura rejeitada?",
  "billRestoredOk": "Fatura restaurada com sucesso",
  "budgetaryAddAccount": "Tem certeza de que deseja adicionar esta conta ao orçamento?",
  "accountAddOk": "Conta adicionada com sucesso ao orçamento",
  "isSecureBill": "Tem certeza de que deseja revisar esta fatura?",
  "accountRevised": "Contas revisadas",
  "isSecurePaymenChildren": "Tem certeza de que deseja propagar o pagamento nas faturas filhas?",
  "paymentOkAlert": "Pagamento propagado com sucesso",
  "viewVoucher": "Ver Recibo",
  "reAsign": "Reatribuir",
  "addNoveltyAccount": "Adicionar novidade de conta",
  "restoredRechazed": "Restaurar Rejeitada",
  "addBudget": "Adicionar ao orçamento",
  "changeBudget": "Alterar orçamento",
  "Outof_budget": "Fora do orçamento",
  "autorizedPayment": "Autorizar pagamento",
  "addNewInvoce": "Adicionar novidade de fatura",
  "addNoveltyToTracking:": "Adicionar novidade ao acompanhamento",
  "slopes": "Pendentes",
  "totallyPayment": "Total a pagar",
  "paid": "Pagadas",
  "totalPaid": "Total pago",
  "assigns": "Atribuído",
  "infoBill": "Informação de fatura",
  "billPendient": "Faturas Pendentes",
  "amountPendient": "Valor Pendentes",
  "porcetain": "Percentagem",
  "rulesAmount": "Regras de Montante",
  "providers": "Prestadores",
  "new": "Novo",
  "assignMissing": "Atribuir Faltantes",
  "redistribute": "Redistribuir",
  "uploadChart": "Carregando o gráfico",
  "updateDate": "Os dados foram atualizados.",
  "and": "e",
  "ejectBoots": "Execução de bots",
  "paymentMarketerService": "P. Serviço mais pagos",
  "digitBillAlerts": "Digitação, Faturas Digitadas Alertas",
  "energyConsumerd": "Energia consumida",
  "lastUpdated": "Última vez atualizado:",
  "value": "Valor",
  "status": "Estado",
  "vertebots": "Vertebots",
  "downloadBill": "Downloads de faturas",
  "infovertebots": "Informação de vertebots",
  "ejecstBoots": "Executar vertebots",
  "idFather": "Id Pai",
  "idOFCompany": "Id da Empresa",
  "totalFather": "Total Pai",
  "noStartDate": "Sem data de início",
  "noEndDate": "Sem data de término",
  "completed": "Completadas",
  "mistake": "Erros",
  "viewDetailOperation": "Ver Detalhe operação",
  "displayInformationAbout": "Exibir informações sobre",
  "hideInformationFrom": "Ocultar informações de",
  "displayLogOf": "Exibir log de",
  "hideLogFrom": "Ocultar log de",
  "uploadedSuccessfully": "carregado com sucesso",
  "whenTryingAlert": "ao tentar enviar o arquivo, tente novamente erro",
  "vertebotStartOk": "Vertebot iniciado com sucesso",
  "ocrEjectOk": "OCR executado com sucesso",
  "oneMeter": "Um medidor",
  "allMeter": "Todos os medidores",
  "youMustUploaderFile": "Você deve carregar um arquivo",
  "clickUploadFile": "Clique ou arraste o arquivo",
  "selectionDateMeter": "Selecione uma data",
  "selectionDateDownloadBullAndAccount": "Selecione uma data para baixar todas as faturas de uma conta",
  "treeDownload": "Árvore de download",
  "attempts": "Tentativas",
  "noBillingDate": "Sem data de faturamento",
  "lastDateAttempts": "Última data de tentativa",
  "noDateAttemptsColumns": "Não há data de última tentativa",
  "datUpdate": "Data de atualização",
  "notDateUpdate": "Sem data de atualização",
  "dateNew": "Data de criação",
  "notDateNew": "Sem data de criação",
  "selectionOne": "Selecione uma",
  "selectionOptionViews": "Selecione uma opção para visualizar os painéis de consumo",
  "rememberOption": "Lembre-se de que esta opção pode demorar um pouco",
  "newLoad": "Criar carga",
  "configurateAvanzedLoad": "Configuração avançada para o medidor:",
  "updatesMeters": "Editar Medidor",
  "stateMeterUpdate": "Estado do medidor modificado",
  "actionStateCanceled": "Ação de mudança de estado cancelada",
  "infoLoad": "Informações da carga",
  "createAlertMeter": "Criar alertas de medidor",
  "description": "Descrição",
  "meteer": "Medidor",
  "typeMeter": "Tipo de medidor",
  "viewUrl": "Ver URL",
  "configAvanzed": "Config. Avançada",
  "viewDetail": "Ver detalhe",
  "loadUpdateOk": "Carga modificada com sucesso",
  "newLoadOk": "Carga criada com sucesso",
  "meterss": "Medidores",
  "inserDescriptionLoad": "Insira uma descrição para a carga...",
  "uploadSupport": "Enviar suporte",
  "textRepeatVoucherUpload": "Já existe um comprovante carregado, se enviar um novo, o comprovante existente será excluído.",
  "instalation": "Instalação",
  "multiplicationFactor": "Fator de multiplicação",
  "relationCTS": "Relação CTS",
  "typeOfMeasure": "Tipo de medida",
  "circuitType": "Tipo de circuito",
  "powerFactor": "Fator de potência",
  "voltage": "Voltagem",
  "createAlert": "Criar alerta",
  "editAlert": "Editar alerta",
  "alertDeleteAlert": "Tem certeza de que deseja excluir este alerta?",
  "alertDeteleOk": "Alerta excluído com sucesso",
  "var": "Variável",
  "temp": "Tempo",
  "alertUpodateOk": "Alerta atualizado com sucesso",
  "alertNewOk": "Alerta criado com sucesso",
  "pleaseInsertVar": "Por favor insira uma variável!",
  "pleaseInsertValue": "Por favor insira um valor",
  "pleaseInsertTemp": "Por favor insira um tempo válido",
  "nameOfCompany": "Nome da empresa",
  "idGroup": "ID do Grupo",
  "nameOfGroup": "Nome do Grupo",
  "idPoint": "ID do Ponto",
  "nameOfPoint": "Nome do Ponto",
  "idMeter": "ID do Medidor",
  "nameMeter": "Nome do Medidor",
  "viewResource": "Ver Recurso",
  "idOfLoad": "ID da Carga",
  "nameOfLoad": "Nome da Carga",
  "infoAvanzedLoad": "Informações avançadas da carga",
  "operationInfo": "A operação não possui informações",
  "newMeter": "Criar Medidor",
  "avanzedConfig": "Configuração avançada",
  "ediMeter": "Editar Medidor",
  "infoMeter": "Informações do Medidor",
  "updatePasswordMeter": "Alterar senha dos medidores",
  "serial": "Serial",
  "protocol": "Protocolo",
  "dateInstalation": "Data de Instalação",
  "lastReport": "Último Relatório",
  "serialOfmMeter": "Serial do Medidor",
  "deviceName": "Nome do Dispositivo",
  "errorAddinfo": "Erro ao adicionar informações",
  "codNameLastAdd": "O código ou o nome do banco de dados já foram adicionados",
  "NameBDLastAdd": "O nome do banco de dados já foi adicionado",
  "addProtocolMod": "Adicionar protocolos modbus",
  "addHeader": "Adicionar cabeçalhos",
  "dataAcquisition": "Aquisição de Dados",
  "frecuencyUnit": "Unidade de frequência",
  "frecuencyValue": "Valor de frequência",
  "configHeader": "Configuração do cabeçalho",
  "addConfigHeader": "Adicionar configuração do cabeçalho",
  "nameHeader": "Nome do cabeçalho",
  "nameBD": "Nome BD",
  "action": "Ação",
  "directionIp": "Endereço IP",
  "port": "Porta",
  "protocolModbus": "Protocolo modbus",
  "addProtocol": "Adicionar Protocolo",
  "register": "Registro",
  "dataLength": "Comprimento dos dados",
  "tData": "T. Dados",
  "typeData": "Tipo de dados",
  "unit": "Unidade",
  "concentrator": "Concentrador",
  "sim": "Sim",
  "simNumber": "Número de sim",
  "subType": "Subtipo",
  "nameOfHeader": "Nome do cabeçalho",
  "idConcentrator": "ID do concentrador",
  "adquitionData": "Aquisição dos dados",
  "infoOfMeter": "Informações do medidor",
  "infoAvanzedMeter": "Informações avançadas do medidor",
  "configModBus": "Configuração ModBUS",
  "notInfoOperation": "A operação não possui informações.",
  "operation": "Operação",
  "typeEmail": "Tipo de E-mail",
  "detailAudit": "Detalhe da Auditoria",
  "fileNoXlsx": "O arquivo não é um xlsx",
  "fileNoZip": "O arquivo não é um zip",
  "uploader": "Uploader",
  "selectEntitie": "Você deve selecionar uma entidade",
  "selectAction": "Você deve selecionar uma ação",
  "downloadExample": "Baixar Exemplo",
  "selectionFile": "Você deve selecionar um arquivo",
  "selectFile": "Selecionar arquivo",
  "selectOneField": "Você deve selecionar pelo menos um campo",
  "selectMergeUnique": "Selecione combinação única...",
  "stringZero": "Considerar vazios como String vazia",
  "selectionMethods": "Selecione método",
  "firstProcess": "Iniciar Processo",
  "History": "Histórico",
  "entiti": "Entidade",
  "process": "Processo",
  "mergeUnique": "Combinação Única",
  "treatmentUpdating": "Tratamento na atualização",
  "aprovved": "Aprovado",
  "isSecureQuestion": "Você tem certeza?",
  "generateReport": "Gerar relatório",
  "dateOfReport": "Data do relatório",
  "selectionYear": "Você deve selecionar o ano",
  "criteryDownload": "Critério de download",
  "selectionCritery": "Você deve selecionar um critério",
  "criteryEDownload": "Critério de download",
  "allGroups": "Todos os grupos",
  "allCompanies": "Todas as empresas",
  "selectionAllGroup": "Você deve selecionar pelo menos um grupo",
  "AllGroupsWereSelected": "Todos os grupos foram selecionados",
  "AllCompaniesWereSelected": "Todas as empresas foram selecionadas",
  "reportCreateExit": "Relatório criado com sucesso",
  "selectionMonth": "Você deve selecionar o mês",
  "selectionDates": "Selecione uma data",
  "allPoint": "Todos os pontos",
  "selectionOnePoint": "Você deve selecionar pelo menos um ponto",
  "selectioAllPoint": "Todos os pontos foram selecionados",
  "selectionMeter": "Você deve selecionar pelo menos um medidor",
  "AllMeterSelection": "Todos os medidores foram selecionados",
  "inserDateValidate": "Você deve inserir uma data válida",
  "typesServices": "Tipos de serviço",
  "selectionOneService": "Você deve selecionar pelo menos um serviço",
  "selectionAllService": "Todos os serviços foram selecionados",
  "selectionOneDigitation": "Você deve selecionar pelo menos um digitador",
  "selectionAllType": "Todos os tipos foram selecionados",
  "creates": "Criado",
  "periode": "Período",
  "payment": "Pagamento",
  "dateUpload": "Data de upload",
  "dateAssing": "Data atribuída",
  "dateExpedition": "Data de expedição",
  "selectionOneRegional": "Você deve selecionar pelo menos uma regional",
  "options": "Opções",
  "consumedMonth": "Consumo mensal",
  "separateCleanLight": "Separação de limpeza",
  "viewsSubProject": "Mostrar Subprojeto",
  "toChooseAllMarketer": "Todas as comercializadoras foram escolhidas",
  "firstDateReport": "Primeira data do relatório",
  "secondDateReport": "Segunda data do relatório",
  "yearAndMonth": "Ano e mês",
  "allServices": "Todos os serviços",
  "ConvertValuePositive": "Converter para Valores Positivos",
  "logSistem": "Log do Sistema",
  "newVersion": "Nova versão",
  "allAccount": "Todas as contas",
  "selectionOneAccount": "Você deve selecionar pelo menos uma conta",
  "allsAccount": "Todas as contas foram selecionadas",
  "reportCreaoteOkAlert": "Relatório criado com sucesso",
  "selectionOneGroup": "Você deve selecionar um grupo",
  "monthReport": "Mês do relatório",
  "load": "Carga",
  "preview": "Pré-visualizar",
  "engrave": "Gravar",
  "budgetAvailible": "Não há orçamentos disponíveis",
  "check": "Verificar",
  "payBill": "Pagar fatura",
  "reviewBill": "Revisar fatura",
  "changePayment": "Alterar Pagamento",
  "spradPaymentAccount": "Propagar pagamento de conta",
  "viewInfo": "Ver Informação",
  "createNoveltys": "Criar Novidades",
  "staticsBill": "Estatísticas de Faturas",
  "selectionBudgetAddBill": "Selecione um orçamento para adicionar à fatura",
  "config": "Configuração",
  "accountRestore": "Conta restaurada",
  "accountGirl": "Conta filha",
  "outOfBudget": "Fora do orçamento",
  "NotPlataformRegister": "Não registrado na plataforma",
  "expiration": "Vencimento",
  "suspend": "Suspensão",
  "due": "Vencimento",
  "notBNudget": "Sem orçamento",
  "dataPayment": "Dados de pagamento",
  "delet": "Excluir",
  "TheFileDelete": "O arquivo foi excluído",
  "recordUploadFile": "Lembre-se de que será carregada uma nova fatura, indicando que mais de uma fatura chegou neste mês",
  "continue": "Continuar",
  "newUploabill": "Enviar uma nova fatura",
  "newUpdateBill": "Alterar Fatura",
  "alertRejectBill": "Lembre-se de que as faturas rejeitadas serão excluídas completamente",
  "rejectBill": "Rejeitar fatura",
  "deleteBill": "Excluir fatura",
  "deleteVoucher": "Excluir comprovante",
  "dateBillPrompt": "Data de pagamento oportuno",
  "NotObservations": "Sem observações",
  "infoBillOf": "informações da fatura de",
  "obsOfTheBill": "Observações da fatura",
  "noveltyOfTheBill": "Novidades da fatura",
  "followBill": "Acompanhar a fatura",
  "conceptTheBill": "Conceitos da fatura",
  "moneyBags": "Bolsas de dinheiro",
  "phones": "Telefonia",
  "mobilePhone": "Telefone Móvel",
  "day": "Dia",
  "selection": "Selecionar",
  "obs": "Observação",
  "selections": "Selecionados",
  "recharge": "Recarregar",
  "aPublic": "A. Público",
  "accountInactive": "Conta inativa",
  "pointInactive": "Ponto inativo",
  "accountAndPointInactive": "Conta e ponto inativos",
  "viewAdmiPoint": "Ver Adm. Pontos",
  "notInvoiced": "Não faturado",
  "configUpdateNotification": "Configuração de notificação atualizada",
  "configTextNotification": "Configuração de notificações de",
  "notificarEi": "Notificar a",
  "whenUploadBill": "quando uma fatura for carregada",
  "whenUploadVoucher": "quando um comprovante for carregado",
  "whenRejectBill": "quando uma fatura for rejeitada",
  "whenSendPetitionBillMarketer": "solicitação de faturas por e-mail",
  "notificationTypeUser": "Notificar ao tipo de usuário",
  "managers": "Gerente",
  "payer": "Pagador",
  "client": "Cliente",
  "loa": "Carga",
  "notTypeUser": "Sem tipo de usuário",
  "petitionBillAcoount": "Petição de fatura à conta",
  "companyUpdateOk": "Empresa atualizada com sucesso",
  "companyNewOk": "Empresa criada com sucesso",
  "pleaseInserrNameValid": "Por favor, insira um nome válido!",
  "pleaseInsertTypeValid": "Por favor, insira um tipo válido!",
  "updateStateAccount": "Alterar estado da conta",
  "auditOfPoint": "Auditorias de pontos",
  "updateStatePointAsk": "Tem certeza de que deseja alterar o estado deste ponto?",
  "stateOfPointUpdate": "Estado do ponto alterado",
  "verificedStanBY": "Verificação pendente",
  "correo": "Correio",
  "stateOfPoint": "Estado do ponto",
  "exportListUpdate": "Exportar listas de alterações",
  "permitNotificationPayment": "Permitir notificações de pagamento",
  "authorizedPaymet": "Pagamento autorizado",
  "lvlSocio": "Nível socioeconômico",
  "lvlVoltage": "Nível de voltagem",
  "userRealizedUpdate": "Usuário que realizou a alteração",
  "notDateOfOperation": "Sem data de operação",
  "noveltyAccount": "Novidades da conta",
  "insertFilePlaneEnel": "Enviar arquivo padrão de Enel",
  "updateStateofAccount": "Alterar estado da conta",
  "IsSecureUpodateStateAccountAsk": "Tem certeza de que deseja alterar o estado desta conta?",
  "stateAcconuntModif": "Estado da conta alterado",
  "auditAccountNumber": "Auditorias do número da conta",
  "ofPoint": "do ponto",
  "pServicio": "P. Serviço",
  "dateTI": "Datas T - I",
  "accountFathers": "C. pai",
  "idNeuAccount": "ID da nova conta",
  "newNameOfAccount": "Novo nome da conta",
  "newMarketerService": "Novo provedor de serviço",
  "updateRealizedFor": "alteração realizada por",
  "lastMarketer": "provedor anterior",
  "updateMarketerForUser": "O usuário alterou o provedor de serviço",
  "he": "ele",
  "eiTheMarketer": "ao provedor de serviço",
  "withAccountNumber": "com número da conta",
  "notUpdateMarketer": "Não houve alteração no provedor de serviço",
  "dateTimelyPayment": "Data de pagamento oportuno",
  "dateInitialOfBilling": "Data inicial de faturamento",
  "paymentAuthorized": "Pagamento autorizado",
  "authorizedForPaiment": "Autorizado para pagamento",
  "dateServices": "Datas de serviços",
  "NumberCuentaEnergy": "# Conta de energia",
  "numberAccountOfStreetLight": "# Conta de iluminação pública",
  "numberAccountWater": "# Conta de água",
  "numberAccountOfSewerage": "# Conta de esgoto",
  "numberAccountCleanlines": "# Conta de limpeza",
  "numberAccountGas": "# Conta de gás",
  "voltageLvl": "Nível de tensão",
  "infoOdfTheAccount": "Informações da conta",
  "editNovelty": "Editar novidades",
  "theGroupDeleteOk": "O grupo foi excluído com sucesso",
  "codOfgroup": "Código do grupo",
  "notName": "Sem nome",
  "dateUploadOfBill": "Data de envio da fatura",
  "dateOfPaymentBill": "Data de pagamento",
  "back": "Voltar",
  "companys": "Empresas",
  "nameOftheTransaction": "Nome da transação",
  "balanceFirst": "Saldo inicial",
  "balanceEnd": "Saldo final",
  "clickFileRates": "Clique ou arraste o arquivo da transação",
  "manualReconciliationss": "Conciliação manual",
  "reconciliation": "Conciliadas",
  "notReconciliation": "Não conciliada",
  "notDate": "Sem data",
  "notReconciliatioons": "Não conciliada",
  "operationConsolidedOk": "Operação consolidada com sucesso",
  "historyBalances": "Histórico de saldos",
  "uploadProofs": "Enviar comprovantes",
  "lastClose": "Último fechamento",
  "dateNotOfFirst": "Data de início",
  "createResouceSource": "Criar origem de recurso",
  "sourceResourceNotNumber": "Origem de recurso sem número",
  "states": "Estados",
  "sorceResourceOk": "Origem do recurso corretamente",
  "budgetCalculation": "Cálculo de orçamento",
  "gestionBudget": "Gerenciar orçamentos",
  "isSecurteDeleteBudgetAlertAsk": "Tem certeza de que deseja excluir este orçamento?",
  "budgetDeleteOk": "Orçamento excluído com sucesso",
  "isSecureAskAprovedBudget": "Tem certeza de que deseja aprovar este orçamento?",
  "theBudgetisAproved": "O orçamento foi aprovado",
  "isSecureDuplicateBudgetAsk": "Tem certeza de que deseja duplicar este orçamento",
  "budgetDuplicateOk": "Orçamento duplicado com sucesso",
  "selectAQuoteToSync": "Selecione um orçamento para sincronizar",
  "budgetCreateOk": "Orçamento criado com sucesso",
  "note": "Nota",
  "textBudgetOne": " As contas que serão usadas para o cálculo do orçamento são aquelas autorizadas para pagamento. Se as faturas ainda não chegaram e não foram digitadas, a data de pagamento aproximada e o valor aproximado de pagamento serão usados.",
  "generateBuget": "Gerar Orçamento",
  "dateCreate": "Data de criação",
  "view": "Visualizar",
  "aprovedQuote": "Aprovar orçamento",
  "downloadDetail": "Baixar Detalhe",
  "duplicateQuote": "Duplicar orçamento",
  "syncBudget": "Sincronizar orçamento",
  "budgetToSyncOk": "Orçamento sincronizado com sucesso",
  "accounrAddOk": "Conta adicionada com sucesso",
  "isPaymentregisterBudget": "Este pagamento já está registrado no orçamento",
  "budgetUpdateOk": "Orçamento modificado com sucesso",
  "isSecureUpdateQuotes": "Tem certeza de que deseja alterar o estado do orçamento",
  "budgetSaveOk": "Orçamento salvo com sucesso",
  "addAccountBudget": "Adicionar conta ao orçamento",
  "filterBills": "Filtrar Faturas",
  "lastBills": "Últ. Fatura",
  "codeOffice": "Cod. Escritório",
  "createRole": "Criar função",
  "editRole": "Editar função",
  "notsverificied": "Não verificado",
  "notSendNotificationsAlert": "O envio de notificações foi desativado",
  "sendNotificationsAlert": "O envio de notificações foi ativado",
  "petitionBillDesactivate": "Petição de Fatura Desativada",
  "petitionBillActivate": "Petição de Fatura Ativada",
  "codMovii": "Código movii",
  "digitVerification": "Dígito de verificação",
  "insertNumberDigitation": "Você deve digitar o número de verificação",
  "modo": "Modo",
  "notificationDelete": "Notificação excluída com sucesso",
  "deleteNotificationAlerQuestion": "Tem certeza de que deseja excluir esta notificação?",
  "createNotification": "Criar notificação",
  "editNotification": "Editar notificação",
  "updateNotificationAlert": "Notificação modificada com sucesso",
  "notificationCreateOk": "Notificação criada com sucesso",
  "petitionBill": "Pedido de fatura para",
  "createConcepts": "Criar conceito",
  "subService": "Sub-serviço",
  "textOneCreateConcetp": "Desativar subprojetos se não se aplicarem ao tipo de serviço",
  "equevalenceExist": "Esta equivalência já existe",
  "equivalence": "Equivalência",
  "atMenosEquivalence": "Pelo menos uma equivalência",
  "fieldObligatoeyValue": "Este campo é obrigatório, por favor insira um valor",
  "nameOfEquevalence": "Nome da equivalência",
  "addNewqEquivalence": "Adicionar uma nova equivalência",
  "saveEquievalence": "Salvar equivalência",
  "saveUpdate": "Salvar alterações",
  "confir": "confirmar",
  "configs": "Configurações",
  "audit": "Auditoria",
  "emailss": "Correio",
  "payment_aut": "Pagamento autorizado",
  "psERVICE": "P. de Serviço",
  "notCity": "Sem cidade",
  "notdeparment": "Sem departamento",
  "notPropieruty": "Sem propriedade",
  "notLvlVariedade": "Sem nível de variação",
  "rateOptional": "Tarifa opcional",
  "basic": "básico",
  "valueFije": "Valor fixo",
  "saldeMinime": "Salários Mínimos",
  "ratesUpdateOk": "Tarifa modificada com sucesso",
  "ratesOkCreate": "Tarifa criada com sucesso",
  "generates": "Geração",
  "tranmition": "Transmissão",
  "distribution": "Distribuição",
  "comercialization": "Comercialização",
  "retriction": "Restrições",
  "lossesAndReduction": "Perdas e redução",
  "valueEnergy": "Valor da energia",
  "optionTarida": "Opção tarifária",
  "valueOption": "Valor da opção",
  "textRatesOne": "Já existe um arquivo carregado, se um novo for carregado, o anterior será excluído",
  "clickFileRatess": "Clique ou arraste o arquivo da tarifa",
  "createSetting": "Criar configuração",
  "editSetting": "Editar configuração",
  "isSecureDeleteSetting": "Tem certeza de que deseja excluir esta configuração?",
  "settingDeleteOk": "Configuração excluída com sucesso",
  "valueColumns": "Valores",
  "ValueOf": "Valores de",
  "viewValues": "Ver valores",
  "table": "Tabelas",
  "tableSyncro": "Tabela sincronizada",
  "syncro": "Sincronizar",
  "viewss": "Visualizar",
  "detailOdoo": "Detalhe Odoo",
  "displayInformation": "Exibir informações",
  "ocultInfo": "Ocultar informações",
  "calculatorAmbiental": "Calculadora ambiental",
  "editPoint": "Editar ponto",
  "isSecureDeleteElement": "Tem certeza de que deseja excluir este elemento?",
  "elementDeleteOk": "Elemento excluído com sucesso",
  "iluminationActivate": "Ativação da iluminação",
  "notIluminationDeactivate": "Sem desativação da iluminação",
  "pointVisit": "Ponto visitado",
  "notPointVisit": "A visita ao ponto foi desativada",
  "aireVisit": "Ativação do ar condicionado",
  "notAireVisit": "Sem ativação do ar condicionado",
  "exportMultiPoint": "Exportar multipontos",
  "iluminations": "Iluminação",
  "aire": "Ar condicionado",
  "visit": "Visita",
  "deleteOeditOne": "Você só pode excluir ou editar um de cada vez",
  "downloadReport": "Baixar relatório",
  "typeOffice": "Tipo de escritório",
  "numbersEmployer": "Número de empregado",
  "activa": "Ativa",
  "reactiva": "Reativa",
  "light": "Iluminação",
  "acueduct": "Aqueduto",
  "numberAccounts": "Número de contas",
  "numberMeters": "Número do medidor",
  "shedules": "Horários",
  "element": "Elemento",
  "photo": "Fotos",
  "elementAddOk": "Elemento adicionado com sucesso",
  "assingGestor": "Atribuir usuários gestores",
  "userAddOk": "Usuários adicionados com sucesso",
  "userDeleteOk": "Usuários excluídos com sucesso",
  "sinAudit": "Sem auditoria",
  "auditPayment": "Auditoria de pagamento",
  "useraddgestor": "Usuários adicionados ao ponto com sucesso",
  "userDeletedGestor": "Usuários excluídos do ponto com sucesso",
  "deleteUser": "Excluir usuário",
  "assignUsers": "Atribuir usuários",
  "adimin": "Administração",
  "totallyBillAnual": "Total de faturas anual",
  "totallyBillMonth": "Total de faturas mensal",
  "billSinBill": "Fatura sem envio",
  "billMonth": "Fatura com frequência mensal",
  "billDigitid": "Faturas digitadas",
  "billFrequencyMontly": "Fatura com frequência bimensal",
  "billPedientDigit": "Faturas pendentes para digitar",
  "billPendie": "Faturas pendentes",
  "billFrequencyTri": "Fatura com frequência trimestral",
  "billPayment": "Faturas pagas",
  "billFrequencyAnual": "Fatura com frequência anual",
  "billReject": "Faturas rejeitadas",
  "formule": "Fórmula",
  "changefrecuency": "Alterar frequência",
  "updloadbillmethod": "Método de carregamento de fatura",
  "makechange": "Alteração realizada com sucesso",
  "incumbent_marketer": "Fornecedores de serviços",
  "emailverification": "Verificar e-mail",
  "removeemailnotification": "Remover verificação de e-mail",
  "executed_mode": "Modo executado",
  "marketer_user_type": "Tipo de usuário",
  "applyfilters": "Aplicar filtros",
  "supervisor": "Supervisionar visualização do pagamento",
  "companies": "Empresas",
  "pay_regionals": "Grupos",
  "types_pay": "Tipos",
  "pays_marketers": "Fornecedores",
  "asignee": "Pagador",
  "payorder": "Ordem de pagamento",
  "filter": "Filtro",
  "supervisortag": "Supervisor",
  "issue": "Data de emissão",
  "reviewModal": "Revisão de faturas",
  "review": "Revisar",
  "reviewsubtype": "Subtipo de revisão",
  "approvepayment": "Aprovar pagamento",
  "removereview": "Remover revisão",
  "restorereview": "Restaurar revisão",
  "payappropve": "Pagamento aprovado",
  "approved_payment": "Pagamento aprovado",
  "digitation_status_filter": "Status de digitação",
  "datebill": "Data de início da faturação",
  "estimate_issue_date": "Data estimada de emissão",
  "budget_apply": "Aplicar orçamento",
  "active": "Ativo",
  "revision_status": "Status de revisão",
  "services_config": "Configuração de serviços",
  "services_message": "Você deve selecionar um serviço",
  "update_settings": "Atualização de configurações",
  "uploadBill": "Carregar fatura",
  "client_upload_bill": "Conta de carregamento do cliente",
  "charger": "Carregador",
  "odoo_alert": "Gerar alertas Odoo",
  "update_bill": "Atualizar conta",
  "consumption_matrix": "Matriz de consumo",
  "fat_file": "Arquivo FAT",
  "conciliations": "Conciliações",
  "movementsandtransfers": "Movimentos e transferências",
  "created_at": "Data de criação",
  "voucher_number": "Número do voucher",
  "date_paid": "Data de pagamento",
  "user_created": "Usuário criado",
  "target": "Objetivo",
  "payment_date": "Data de pagamento",
  "date_bill": "Data da conta",
  "real_payment": "Pagamento real",
  "paid_date": "Data de pagamento",
  "regional_name": "Regional",
  "number_bill": "Número da conta",
  "payment_reference": "Referência de pagamento",
  "cash_source_name": "Fonte de dinheiro",
  "account_name": "Número da conta",
  "payment_method_marketer_name": "Método de pagamento",
  "is_consolidated_true": "Consolidado",
  "is_consolidated_false": "Não consolidado",
  "payment_tax": "Impostos",
  "consolidated": "Consolidado",
  "not_consolidated": "Não consolidado",
  "property_level": "Nível de propriedade",
  "voltaje_level": "Nível de tensão",
  "phone_number": "Número de telefone",
  "guru_groups": "Grupos do Guruve",
  "clear_selections": "Limpar seleções",
  "places": "Pontos",
  "max_three_selected": "Você pode selecionar no máximo três grupos",
  "history": "Histórico",
  "get_history_id_message": "Você deve selecionar um usuário para exibir seu histórico de dados.",
  "operation_name": "Operação",
  "cash_source": "Fonte de dinheiro",
  "see_history": "Ver histórico do usuário",
  "messages": "Mensagens",
  "see_messages": "Ver mensagens do usuário",
  "schedules": "Agendamentos",
  "message_title": "Título da mensagem",
  "message": "Mensagem",
  "buttons": "Botões",
  "guruve_buttons_add": "Adicionar botões à mensagem",
  "section_title": "Título da seção",
  "body_message": "Insira as especificações do formulário.",
  "body_message_title": "Corpo do formulário",
  "guru_message_types": "Tipos de mensagem",
  "guru_messages_status": "Status da mensagem",
  "total_sent": "Total de mensagens enviadas",
  "send_date": "Data de envio",
  "send_date_and_hour": "Data e hora de envio",
  "included_groups": "Grupos incluídos",
  "excluded_groups": "Grupos excluídos",
  "included_users": "Usuários incluídos",
  "excluded_users": "Usuários excluídos",
  "includ_all": "Incluir todos",
  "programing": "Programação",
  "targets": "Metas",
  "get_schedule_message_info": "Você deve selecionar uma mensagem para exibir sua configuração.",
  "aprove": "Aprovar",
  "reject": "Rejeitar",
  "send_test": "Enviar teste",
  "send_date_and_hour_message": "Sua mensagem foi programada para ser enviada na data e hora desejadas, se você desejar modificá-la você pode fazê-lo antes da hora marcada.",
  "change_message": "Mudar mensagem",
  "duplicated": "Duplicar",
  "click_and_drag": "Clique ou arraste o arquivo para esta área para fazer upload",
  "click_and_drag_message": "Suporte para upload único. É estritamente proibido fazer upload de dados da empresa ou outros arquivos não autorizados.",
  "direct_debit_payment": "Débito Direto",
  "changePriority": "Alterar Prioridade",
  "changeNormalToPriority": "Alterar para Prioridade Normal",
  "changeHighToPriority": "Alterar para Prioridade Alta",
  "priority": "Prioritário",
  "ready_for_approval": "Pronto para aprovação",
  "scheduled": "Aprovado e agendado",
  "sent": "Enviado",
  "rejected": "Rejeitado",
  "cancelled": "Cancelado",
  "sending_message": "Enviando mensagem",
  "delivered": "Entregue",
  "received": "Recebido",
  "seen": "Visto",
  "text": "Texto",
  "list": "Lista",
  "media": "Mídia",
  "button": "Botão",
  "button_reply": "Resposta de botão",
  "list_reply": "Resposta de lista",
  "sticker": "Sticker",
  "incoming": "Entrada",
  "no_message": "Nenhuma mensagem",
  "sent_at": "Enviado",
  "delivered_at": "Entregue",
  "read_at": "Lido",
  "see_more": "Ver mais",
  "information": "Informação",
  "add_form_field": "Adicionar campo de formulário",
  "add_list_item": "Adicionar item de lista",
  "add_button_field": "Adicionar botão",
  "edit_schecule_message": "Editar mensagem programada",
  "saving": "Salvando...",
  "payment_method": "Forma de pagamento",
  "edit_message_name": "Editar nome da mensagem",
  "edit_schedule": "Editar contenidos",
  "clear_last_selections": "Limpar últimas seleções",
  "total_user_bill_downloads": "Número total de logs concluídos",
  "estimated_upload_date": "Data de upload estimada",
  "upload_month": "Mês de upload",
  "scheduled_at": "Programado para",
  "mode": "Modo",
  "review_sub_type": "Subtipo de revisão",
  "assigned": "Atribuído",
  "total_pending": "Total pendente",
  "total_pending_priority": "Total pendente prioritário",
  "assignee_charger": "Atribuir carregador",
  "assignee_payer": "Atribuir pagador",
  "digitation_status": "Status da digitação",
  "user_bill_download": "Baixar conta do usuário",
  "remove_children_account": "Remover do padrão",
  "action_sucesfull": "Ação realizada com sucesso",
  "remove_account_of_bill_parent": "Remover conta da conta pai",
  "remove_pay_from_bill": "¿Você deseja remover esta fatura do pagamento?",
  "payment_method_suggest": "Sugerir forma de pagamento",
  "upload_parent_file_bill": "Carregar arquivo de fatura pai",
  "clickUploadBill": "Clique para carregar a fatura",
  "simple_mode": "Modo simples",
  "report_mode": "Modo de relatório",
  "childs": "Filhas",
  "parent": "Pai",
  "loader": "Carregador",
  "add_selected": "Adicionar selecionado",
  "automatic_debit": "Débito automático",
  "energy_border": "Fronteira",
  "account_cession": "Cessão de conta",
  "account_cession_susecfull": "Conta cedida com sucesso",
  "accounts": "Contas",
  "stratum": "Estrato",
  "position": "Posição",
  "id_card": "Cédula",
  "bill_upload": "Carregar fatura",
  "total files": "Total de ficheiros",
  "difference": "diferença",
  "reconciled": "reconciliado",
  "notCancelled": "Não cancelado",
  "number_of_agreement": "Número de acordo",
  "date_ipp_ipc_base": "Data IPP/IPC base",
  "contributing_rate": "Taxa de contribuição",
  "collection_method": "Método de coleta",
  "help": "Ajuda",
  "rates_hepl_one": "Variáveis armazenadas com um símbolo Hash/Cerquilha #",
  "rates_hepl_two": "Deixe um espaço antes de declarar uma variável",
  "rates_hepl_three": "Separe cada dado com vírgula, por exemplo: (#SMMLV + 30), (#SMMLV+30)*15",
  "rates_hepl_four": "Ao usar um operador ternário, lembre-se de usar '?' e depois ':' Exemplo:",
  "rates_hepl_five": "É usado para um '&&' e o que é usado para um '||'",
  "rates_hepl_six": "No caso de um operador ternário aninhado não ter a última validação, por favor, defina o valor como VERDADEIRO.",
  "public_lighting_fee": "Taxa de iluminação pública",
  "timely_payment_date_budget": "Data estimada de pagamento do orçamento",
  "daily_number": "Número diário",
  "filter_date": "Filtrar por data",
  "ilumination_office": "Iluminação oficina",
  "aires_office": "Aires oficina",
  "ilumination_atm_office": "Iluminação ATM oficina",
  "aires_atm_office": "Aires ATM oficina",
  "aire_data_center": "Aire data center",
  "hydric": "Hídrico",
  "init_date": "Data de início",
  "end_date": "Data final",
  "add_investments": "Adicionar investimentos",
  "base_lines": "Linhas de base",
  "remove_cession": "Remover cessão",
  "bot_upload_bill": "Bot de subida de factura",
  "implementation_upload_bill": "Implementação de subida de factura",
  "timely_payment_date": "Data de pagamento pontual",
  "consumption": "Consumo",
  "image_bill": "Fatura de imagem",
  "create_account": "Criar conta",
  "upload_bill": "Carregar fatura",
  "view_upload_bill_info": "Ver informações da fatura carregada",
  "account_relationship": "Relação de conta",
  "budgetFixed": "Orçamento fixo",
  "unreconciledTransactions": "Transações não reconciliadas",
  "user_information": "Informação do usuário",
  "add_guru_mode_message": "Para acessar este módulo, você deve adicionar um modo de guruve ao seu perfil de usuário através do seguinte link:",
  "message_template": "Modelo de mensagem",
  "template_message_intro": "Bem-vindo! Neste espaço, você terá a oportunidade de escolher o modelo perfeito para sua mensagem de boas-vindas no WhatsApp.",
  "header": "Cabeçalho",
  "messages_lobby": "Bem-vindo ao formulário de criação de mensagens da Guruve! Aqui você terá a oportunidade de configurar e personalizar a sua mensagem de acordo com o seu gosto.",
  "messages_lobby_1": "Escolha e personalize o modelo de boas-vindas para a sua mensagem.",
  "messages_lobby_2": "Crie mensagens de acordo com suas preferências.",
  "messages_lobby_3": "Interaja com os usuários do bot criando condições de resposta para as mensagens enviadas.",
  "conditions_title": "Condições",
  "conditions_message_intro": "Aqui você pode gerar condições para as mensagens que você envia através do Guruve, as quais podem ser usadas para validar mensagens, oferecer opções para o usuário selecionar uma alternativa ou outra, e muito mais.",
  "conditions_message_example": "Estes são exemplos de uso de uma condição: $id_mensagem.value === 'Sim' para consultar uma idade, por exemplo, ou validar se o consumo de faturas é alto: $consumo_fatura.value > '100000' ou $age.value > '18', entre muitas outras consultas e validações.",
  "message_intro": "Personalize suas mensagens ao seu gosto para serem enviadas através do Guruve. Você pode enviar vídeos, imagens e adesivos.",
  "add_on_tree": "Adicionar à árvore de mensagens",
  "export_users_bill_upload": "Exportar usuários com faturas carregadas",
  "dates_information": "Informações de datas",
  "origin_type": "Tipo de origem",
  "start_date": "Data de início",
  "destination_name": "Nome de destino",
  "no_interactions": "Você deve selecionar uma interação para poder ver as informações das mensagens enviadas.",
  "interactions": "Interações",
  "export_sent_messages": "Exportar mensagens enviadas",
  "points": "Pontos",
  "carbon_print": "Pegada de carbono",
  "meters_variation": "Variação de bitola",
  "energy": "Energia",
  "see_carbon_footprint": "Ver pegada de carbono",
  "alerts": "Alertas",
  "total_active_energy": "Energia ativa total",
  "total_reactive_energy": "Energia reativa total",
  "average_consumption": "Consumo médio",
  "actual_savings": "Economia real",
  "last_year": "Último ano",
  "company_information": "Informações da empresa",
  "monthly_comparison": "Comparação mensal",
  "values": "Valores",
  "energy_consumption": "Consumo de energia",
  "reactive_power_consumption": "Consumo de energia reativa",
  "base_consumption": "Consumo básico",
  "hide_accounts_without_data": "Ocultar contas sem dados",
  "billUpload": "Upload de fatura",
  "massive_logbook": "Livro de registro em massa",
  "provison_synlab_file": "Arquivo de provisão Synlab",
  "filter_base_consumption": "Consumo de base do filtro",
  "relationship": "Relação",
  "user_id": "ID do usuário",
  "token_api": "Token API",
  "celsia_mail": "E-mail Celsia",
  "subscription_key": "Chave de assinatura",
  "jump_message_intro": "Você pode usar os saltos para saltar para uma mensagem específica usando os IDs das mensagens.",
  "jump": "Saltar",
  "projected": "Projetado",
  "vertebracanmakethepay": "Vertebra pode fazer o pagamento",
  "old_account_change_marketer": "O usuário [user_make_change] realizou uma mudança de comercializadora do fornecedor [old_provider] para o fornecedor [new_provider] da conta [old_account] para a conta [new_account] com registro de XM [datexm] na data [date]. A mudança está sob a modalidade [modality] e a modalidade de venda é [sales_modality].",
  "new_account_change_marketer": "O usuário [user_make_change] gerou a mudança de comercializadora da conta [old_account] para a conta [new_account] com registro de Xm [datexm].  a data de modificação é [date].",
  "document": "Documento",
  "removeChangeMarketer": "Remover mudança de comercializadora",
  "not_registered": "Não registrado",
  "respel": "Respel",
  "internet": "Internet",
  "application": "Aplicação",
  "message_name": "Nome da mensagem",
  "multiple_company_schedule": "Programação de várias empresas",
  "unbilled_month": "Mês não faturado",
  "invoice_account": "Conta de faturamento",
  "withoutBiReport": "Você não possui relatórios atribuídos a esta empresa",
  "see_childrens": "Ver filhos",
  "see_provider": "Ver provedor de serviços",
  "see_company": "Ver empresa",
  "parent_account": "Conta pai",
  "Scheduled": "Programado",
  "schedule_messages": "Mensagens programadas",
  "extra_info": "Informações extras",
  "message_extra_info": "Informações extras da mensagem",
  "error_validation": "Erro de validação",
  "validation": "Validação",
  "startwith": "Começa com",
  "endwith": "Termina com",
  "subtype": "Subtipo",
  "optional_info": "Informação opcional",
  "message_optional_info": "Informação opcional da mensagem",
  "exeptionCommand_type": "Tipo de comando de exceção",
  "exeptionCommandText": "Texto de comando de exceção",
  "sendNext": "Enviar próximo",
  "vertebra_can_pay": "Vertebra pode pagar",
  "type_place": "Tipo de lugar",
  "changeMarketer": "Mudança de comercializadora",
  "has_account_cession": "Cessão de conta",
  "novelty_account": "Novidade da conta",
  "office_code": "Código do escritório",
  "estimatePaymentDate": "Data estimada de pagamento",
  "new_marketer": "Novo comercializador",
  "withoutData": "Sem dados",
  "switchVerification": "Mudar verificação",
  "withoutInformation": "Sem informação",
  "street_lighting": "Iluminação pública",
  "cleanliness": "Limpeza",
  "insertbillpetition": "Inserir o número da conta",
  "upload_enel_file": "Carregar arquivo Enel",
  "assigned_payer": "Pagador atribuído",
  "estimate_payment_date": "Data estimada de pagamento",
  "initial_payment_date": "Data de pagamento inicial",
  "final_payment_date": "Data de pagamento final",
  "billing_to": "Faturamento",
  "iva_value": "Valor do IVA",
  "telemetry_value": "Valor da telemetria",
  "data_plan_vallue": "Valor do plano de dados",
  "dateChange": "Data de mudança",
  "sell_modality": "Modalidade de venda",
  "spot_date": "Data do pagamento à vista",
  "financing_date": "Data de financiamento",
  "number_of_payments": "Número de pagamentos",
  "final_pay_date": "Data de pagamento final",
  "remove_change_marketer": "Remover mudança de comercializadora",
  "export_interactions": "Exportar interações",
  "export_unregistered_user_interactions": "Exportar interações de usuários não registrados",
  "discounted_call": "Discounted call",
  "unregistered_users": "Usuários não registrados",
  "brand": "Marca",
  "typeEquipment": "Tipo de equipamento",
  "lightingType": "Tipo de iluminación",
  "inventory": "Inventário",
  "account_changes": "Mudanças de conta",
  "mode_of_sale": "Modo de venda",
  "offer_number": "Número da oferta",
  "modality": "Modalidade",
  "investments": "Investimentos",
  "change_date_to_regulatory_bodies": "Data de alteração aos órgãos reguladores",
  "valve": "Válvula",
  "meter_characterization": "Caracterização do medidor",
  "include_points_without_investments": "Incluir pontos sem investimentos",
  "include_points_without_inventory": "Incluir pontos sem inventário",
  "with": "Com",
  "without": "Sem",
  "error": "Erro",
  "message_information": "Informação da mensagem",
  "week": "Semana",
  "budget_value": "Valor do orçamento",
  "budget_value_not_equal_total": "O valor do orçamento não é igual ao total",
  "budget_account_date": "Data orçada",
  "payment_immediate": "Pagamento imediato",
  "diferent_values": "Valores diferentes",
  "export_account": "Exportar conta",
  "export_bills_history": "Exportar histórico de faturas",
  "bills_without_export": "Faturas sem exportação",
  "current": "Atual",
  "previous": "Anterior",
  "payment_today": "Pagamento hoje",
  "expires_today": "Expiran hoje",
  "active_since": "Ativo desde",
  "compare_budgets": "Comparar orçamentos",
  "indexer": "Indexador",
  "base_date": "Data base",
  "adequacy_value": "Valor de adequação",
  "equipment_value": "Valor dos equipamentos",
  "labor_cost_value": "Valor da mão de obra",
  "exit_penalty_percentage": "Percentagem de penalização de saída",
  "year": "Ano",
  "weeks_configuration_json": "JSON de configuração de semanas",
  "configure_service_percentages": "Configurar as porcentagens dos serviços",
  "service_percentages_for_budget_calculation": "Percentagens de serviços para cálculo do orçamento",
  "market": "Mercado",
  "payer_mode": "Modo de pagamento",
  "reviewer_modo": "Modo de revisão",
  "audit_mode": "Modo de auditoria",
  "bill_finder_mode": "Modo de busca de fatura",
  "modes": "Modos",
  "recalculate_weeks": "Recalcular semanas",
  "last_bot_type": "Último tipo de bot",
  "dNoHave": "Não tem",
  "queueBudgetManagement": "Gestão de orçamentos",
  "manage": "Gerenciar",
  "icon": "Ícone",
  "remove_from_budget": "Remover do orçamento",
  "out_budget": "Fora do orçamento",
  "in_budget": "Dentro de presupuesto",
  "roolback": "Roolback",
  "change_budget": "Alterar orçamento",
  "not_waiting": "Não esperando",
  "bill_arrive": "Fatura chega",
  "bill_not_arrive": "Fatura não chega",
  "arrives": "Chega",
  "waiting": "Esperando",
  "is_external_pay": "É um pagamento externo",
  "assing_massive_groups": "Atribuir grupos em massa",
  "deactivate_users": "Desativar usuários",
  "active_users": "Usuários ativos",
  "remenber": "Lembre-se",
  "assing_many_groups_warning": "Os grupos serão atribuídos a usuários que atendam aos critérios do intervalo de filtros.",
  "invoice_search": "Busca de faturas",
  "last_log": "Último registro",
  "configure_uploader_permissions": "Configurar permissões do uploader",
  "expires_at": "Expira em",
  "pin": "Pin",
  "link": "Link",
  "section": "Seção",
  "extra": "Extra",
  "old_provider": "Fornecedor antigo",
  "new_provider": "Novo provedor",
  "old_account": "Conta antiga",
  "new_account": "Nova conta",
  "registre_date": "Data de registro",
  "sales_modality": "Modalidade de venda",
  "change_marketer": "Mudança de comercializadora",
  "user_make_change": "Usuário que fez a mudança",
  "market_type": "Tipo de mercado",
  "assigned_real_date": "Data real atribuída",
  "no_reclassification": "Não usar reclassificação",
  "guru_type": "Tipo de guru",
  "define_template": "Definir modelo",
  "guruve_mode": "Modo Guruve",
  "template": "Modelo",
  "optional": "Opcional",
  "header_description": "Escolha o tipo de conteúdo multimídia que você usará para o cabeçalho da sua mensagem. (só pode ser escolhido um)",
  "header_type": "Tipo de cabeçalho",
  "none": "Nenhum",
  "image": "Imagem",
  "video": "Vídeo",
  "body": "Corpo da mensagem",
  "body_description": "Para personalizar o corpo da mensagem, insira o texto que deseja exibir. Você pode usar variáveis para personalizar ainda mais a mensagem. As variáveis são inseridas da seguinte maneira: {{número da variável}}. Exemplo: {{1}}. Certifique-se de atribuir números de variáveis em ordem crescente para que a mensagem seja exibida corretamente.",
  "characters": "Caracteres",
  "add_variable": "Adicionar variável. Além disso, você pode pressionar a tecla # para exibir um menu com várias opções.",
  "actions": "Ações",
  "actions_description": "Defina o tipo de ação que você deseja mostrar quando o usuário receber a mensagem.",
  "comment_cannot_contain_quotes": "O comentário não pode conter aspas simples ou duplas",
  "add_log": "Adicionar registro",
  "created_by": "Criado por",
  "log_today": "Registro de hoje",
  "ipp_ipc_date_configuration": "Configuração de data IPP/IPC",
  "telephony": "Telefonia",
  "television": "Televisão",
  "con_ocr": "Com OCR",
  "reason_user_charge": "Motivo de carga do usuário",
  "novelty_prevents_invoice_search": "Novidade impede busca de fatura",
  "inconsistent_charger": "Cargador incongruente",
  "manageCredentials": "Gerenciar credenciais",
  "duplicateCredentialAlertTitle": "Credencial duplicada",
  "duplicateCredentialAlertDescription": "Já existe uma credencial salva para esta empresa. Ao salvar, será solicitada a confirmação da substituição.",
  "duplicateCredentialConfirmTitle": "Já existe uma credencial para esta empresa",
  "duplicateCredentialConfirmText": "Já existe uma credencial salva para <b>{{company}}</b>. Se continuar, esses dados serão substituídos pelos que você acabou de inserir.",
  "duplicateCredentialReplace": "Substituir",
  "public_lighting_short": "I. pública",
  "bot_statistics": "Estatísticas de bots",
  "bots_executed": "Bots executados",
  "exitosos": "Bem-sucedido",
  "error_types": "Tipos de erros",
  "without_invoice": "Sem fatura",
  "error_count": "Número de erros",
  "error_type": "Tipo de erro",
  "emails": "E-mails",
  "generate_official_letter": "Gerar ofício",
  "add_accounts": "Adicionar contas",
  "remove_accounts": "Remover contas",
  "at_claiming": "Reclamando",
  "remove_claim": "Remover reclamação",
  "guilty": "Culpado",
  "page_error": "Erro na página",
  "in_process": "Em processo",
  "total_attempts": "Total de tentativas",
  "view_all_details": "Ver todos os detalhes",
  "completeds": "Completados",
  "consumption_calculation": "Cálculo de consumos",
  "created_provider_ticket": "Criou ticket para o prestador",
  "file_number": "Número do protocolo",
  "created_from": "Criado a partir de",
  "open_invoice_history": "Abrir histórico de faturas",
  "invoice_history": "Histórico de faturas",
  "parent_account_label": "(Pai)",
  "issue_date": "Data de emissão",
  "suspension_date": "Data de suspensão",
  "no_invoice_selected": "Nenhuma fatura selecionada",
  "created_by_bulk_logs": "Criado por logs em massa",
  "updateNoveltyAccount": "Editar problema de conta",
  "unit_cost": "Costo unitario",
  "tariff_recovery_cost": "Custo de recuperação tarifária",
  "view_bills": "Ver faturas",
  "uploader_error": "Arquivo com erros",
  "uploader_error_subtitle": "Por favor, verifique e modifique as informações do arquivo antes de fazer o upload novamente",
  "uploader_error_description": "O conteúdo que você enviou tem os seguintes erros",
  "uploader_redirect_dashboard": "Redirecionar para o painel",
  "status_report": "Relatório de status",
  "upload_massive_file": "Carregar arquivo em massa",
  "is_multiple": "É múltiplo",
  "provider_inactive_since": "Este prestador está inativo desde",
  "selected_point": "Ponto selecionado",
  "not_selected": "Não selecionado",
  "zip_conditions": "Para carregar os dados corretamente, certifique-se de que: \n* Os arquivos no ZIP correspondem ao formato do modelo. \n* Os arquivos PDF têm o formato código_do_país-número_de_telefone.formato. \nexemplo: 573XXXXXXXXX.pdf",
  "donwloadZip": "Baixar ZIP",
  "total_rows": "Total de linhas",
  "total_ok": "Total OK",
  "total_error": "Total de erros",
  "last_update": "Última atualização",
  "job_id": "ID do trabalho",
  "entity": "Entidade",
  "proccess_and_ignore_errors": "Processar e ignorar erros",
  "this_process_can_take_a_while": "Este processo pode levar um tempo",
  "download_report": "Baixar relatório",
  "display_errors": "Exibir erros",
  "payment_information": "Informação de pagamento",
  "searching_information": "Buscando informação",
  "eguru": "Eguru",
  "visitado": "Visitado",
  "edit_investments": "Editar investimentos",
  "additional_days": "Dias adicionais",
  "add_issue": "Adicionar novidade",
  "account_issue": "Problema de conta",
  "invoice_issue": "Problema de fatura",
  "internal_use_issue_vertebra": "Problema de uso interno Vertebra",
  "budget_issue": "Problema de orçamento",
  "closed_account_issue": "Problema de conta fechada",
  "change_bill": "Mudança de faturas",
  "invoice_value_affecting_account_issue": "Problema de conta que afeta o valor da fatura",
  "updated_at": "Atualizado em",
  "total_cargada": "Total carregadas",
  "total_digitadas": "Total digitadas",
  "total_no_facturadas": "Total não faturadas",
  "increase_alerts": "Alertas de aumento",
  "decrease_alerts": "Alertas de diminuição",
  "average_alerts": "Alertas em média",
  "total_alerts": "Total de alertas",
  "view_alerts": "Ver alertas",
  "alert_type": "Tipo de alerta",
  "alert_status": "Estado de alerta",
  "alert_month": "Mês de alerta",
  "current_consumption": "Consumo atual",
  "comparison_consumption": "Comparação de consumo",
  "variation": "Variação",
  "return_to_average": "Retorno à média",
  "last_year_consumption": "Consumo do último ano",
  "alerts_chart": "Consumo do ano",
  "perform_tracking": "Realizar acompanhamento",
  "ticket": "Ticket",
  "registration_successful": "Registro realizado com sucesso",
  "mark_as_not_real": "Marcar como não realizado",
  "mark_as_not_real_description": "A alerta será marcada como não real e deixará de aparecer",
  "marked_as_not_real": "Marcada como não real",
  "is_real": "É real",
  "digitation_error": "Erro de digitação",
  "new_status": "Novo estado",
  "file_will_arrive_soon": "O arquivo chegará em alguns minutos ao e-mail",
  "revert_closed": "Reverter fechado",
  "confirm_revert_status": "Tem certeza de que deseja reverter o estado desta alerta?",
  "last_tracking_date": "Data do último acompanhamento",
  "showing": "Mostrando",
  "hiding": "Ocultando",
  "parent_accounts": "Contas pai",
  "child_accounts": "Contas filhas",
  "other_accounts": "Outras contas",
  "parent_and_child_accounts": "Contas pai e filho",
  "accounts_excluding_children": "Contas excluindo filhos",
  "accounts_excluding_parents": "Contas excluindo pais",
  "indifferent": "Indiferente",
  "all_companies": "Todas as empresas",
  "load_another_bill": "Carregar outra fatura",
  "view_meter_alerts": "Visualizar alertas do medidor",
  "meter_alerts": "Alertas de medidores",
  "increase": "Aumento",
  "decrease": "Diminuição",
  "net_balance": "Saldo líquido",
  "maximum": "Máximo",
  "optimal_maximum": "Máximo ótimo",
  "average": "Média",
  "minimum": "Mínimo",
  "optimal_minimum": "Mínimo ótimo",
  "chart": "Gráfico",
  "view_full_screen": "Ver tela cheia",
  "last": "Último",
  "tracking": "Acompanhamento",
  "parent_company": "Empresa mãe",
  "next": "Próximo",
  "mark_as_not_real_question": "Tem certeza de que deseja marcar este alerta como não real? Isso também a fechará",
  "comparison": "Comparação",
  "average_1_year": "Média 1 ano",
  "average_6_months": "Média 6 meses",
  "insertFilePlaneClaro": "Insira o arquivo do plano Claro",
  "add_filters": "Adicionar filtros",
  "remove_filter": "Remover filtro",
  "filter_limit_reached": "Limite de filtros alcançado",
  "save_filter_settings": "Salvar configurações de filtro",
  "addUserCredentials": "Adicionar credenciais de usuário",
  "save_filter_prompt": "Se aceitar, a configuração atual do filtro será salva. Cada vez que você abrir este módulo pela primeira vez, esta configuração será carregada",
  "ignore_atypical_consumption": "Ignorar consumo atípico",
  "view_tracking": "Ver acompanhamento",
  "scheduled_start": "Início programado",
  "scheduled_end": "Fim programado",
  "total_lesson": "Total de aulas",
  "progress": "Progresso",
  "eguru_courses": "Cursos do Eguru",
  "instances": "Instâncias",
  "category": "Categoria",
  "course_setup": "Configuração do curso",
  "complete_all_fields": "Complete todos os campos",
  "customize_your_course": "Personalize seu curso",
  "lessons": "Aulas",
  "course_name": "Nome do curso",
  "course_description": "Descrição do curso",
  "course_image": "Imagem do curso",
  "course_chapters": "Capítulos do curso",
  "drag_and_drop_to_reorder_chapters": "Arraste e solte para reordenar os capítulos",
  "active_course": "Curso ativo",
  "no_chapters": "Sem capítulos",
  "add_module": "Adicionar módulo",
  "module_name": "Nome do módulo",
  "add_module_name": "Adicionar nome do módulo",
  "add_chapter": "Adicionar capítulo",
  "compliance": "Conformidade",
  "civil_liability": "Responsabilidade civil",
  "offer_sincerity": "Seriedade da Oferta",
  "insurance_policy": "Política de seguro",
  "subservices": "Subserviços",
  "total_lessons": "Total de aulas",
  "contend": "Conteúdo",
  "datail": "Detalhe",
  "last_access": "Último acesso",
  "instance_status": "Estado da instância",
  "on_progress": "Em progresso",
  "previous_status": "Estado anterior",
  "deactivate_account": "Desativar conta",
  "account_deactivated_successfully": "A conta foi desativada com sucesso",
  "active_period": "Período ativo",
  "case_title": "Título para o caso",
  "create_odoo_ticket": "Criar ticket Odoo",
  "configure_periods": "Configurar períodos",
  "add_date_range": "Adicionar intervalo de datas",
  "thermal_energy": "Energia térmica",
  "total_reviewed": "Total revisado",
  "total_no_reviewed": "Total não revisado",
  "no_reviewed_days": "Dias não revisados",
  "not_review_in_a_last_two_days": "Não revisado nos últimos dois dias",
  "subject": "Assunto",
  "from_email": "De e-mail",
  "has_attachment": "Tem anexo",
  "attachment": "Anexo",
  "is_reviewed": "Está revisado",
  "from": "De",
  "to": "Para",
  "to_me": "Para mim",
  "replay_to": "Responder para",
  "bot_reviewed": "Bot revisado",
  "comment": "Comentário",
  "remove_review": "Remover revisão",
  "edit_review": "Editar revisão",
  "no_reviewed_day": "Dia não revisado",
  "bot_not_reviewed": "Bot não revisado",
  "total_lessons_completed": "Total de aulas concluídas",
  "view_comments": "Ver comentários",
  "total_completed": "Total concluído",
  "in_progress": "Em progresso",
  "comments_instance": "Comments instance",
  "total_comments": "Total de comentários",
  "reload": "Recarregar",
  "comments_description": "Aqui você pode encontrar os comentários de cada lição da instância. Se uma lição não tiver comentários, nada aparecerá para mostrar.",
  "is_completed": "Está concluído",
  "lesson": "Aula",
  "contend_time": "Tempo de conteúdo",
  "id_video": "ID do vídeo",
  "upload_video": "Carregar vídeo",
  "total_pages": "Total de páginas",
  "add_lesson": "Adicionar aula",
  "courses": "Cursos",
  "add_lessons_to_save": "Adicione aulas para salvar o curso",
  "used_massive_log": "Registro em massa foi utilizado",
  "searchBills": "Buscar faturas",
  "bots_execution": "Execução de bots",
  "export_policy": "Exportar apólice",
  "measurement_location": "Local de medição",
  "max_budget": "Orçamento máximo",
  "max_value": "Valor máximo",
  "digital_status": "Estado digital",
  "total_accounts": "Total de contas",
  "total_paymentgis": "Total de pagamentos",
  "execute_accounts_in_this_cluster": "Executar contas neste cluster",
  "image_upload_flag": "La imagen no es obligatoria en este modo. Si se carga una imagen, solo aparecerá en el encabezado del texto.",
  "tags": "Etiquetas",
  "upload_attachment": "Cargar adjunto",
  "include_policy": "Incluir apólice",
  "export_only_policy": "Exportar apenas apólice",
  "attachments": "Adjuntos",
  "more": "Más",
  "total_users": "Total de usuarios",
  "downloaded_files": "Arquivos baixados",
  "parents_only": "Só pais",
  "forum": "Requerimento de comentário para completar a lição.",
  "file_info": "Información del archivo",
  "file_name": "Nombre del archivo",
  "size_file": "Tamaño del archivo",
  "upload_bill_description": "Cargar factura a una cuenta",
  "bill_description_one": "Obtenha uma cópia da fatura que você deseja carregar na conta.",
  "upload_bill_description_two": "Verifique os detalhes da conta a ser cobrada pela fatura, incluindo o número da conta, a empresa e outras informações.",
  "account_info": "Información da conta",
  "see_last_bill": "Ver a última fatura",
  "last_bill": "Última fatura",
  "automatically_upload": "Carregar automaticamente",
  "upload_date": "Data de carga",
  "see_upload_bills_view": "Ver facturas carregadas",
  "see_bill": "Ver factura",
  "report_generated_successfully": "Relatório gerado com sucesso",
  "executions_last_60_min": "Execuções últimos 60 min",
  "available_executions": "Execuções disponíveis",
  "go_back": "Voltar",
  "perform_new_execution": "Realizar nova execução",
  "end": "Fim",
  "execute": "Executar",
  "select_accounts": "Selecionar as contas",
  "selected": "Selecionadas",
  "are_you_sure_to_select": "Tem certeza de selecionar",
  "bot_executed": "Bot executado",
  "cancel_execution": "Cancelar execução",
  "without_cluster": "Sem cluster",
  "execute_cluster_and_without_cluster": "Executar cluster {{cluster}} e os que não têm cluster",
  "remove_selection": "Remover seleção",
  "last_execution": "Última execução",
  "max_characters_allowed": "Máximo de {{charactersAllowed}} caracteres permitidos",
  "successful_export": "Exportação bem-sucedida",
  "info_will_arrive_in_minutes_to_email": "As informações chegarão em alguns minutos ao e-mail {{email}}",
  "account_change": "Mudança de conta",
  "massive_updates": "Atualizações em massa",
  "close_novelties": "Fechar novidades",
  "close_massive_novelties_confirm": "Se você aceitar todas as novidades em massa desta execução, elas serão fechadas",
  "add_massive_comments": "Adicionar comentário em massa",
  "invoice_uploader": "Carregador de faturas",
  "created_by_cluster": "Criado por cluster",
  "are_you_sure": "Tem certeza?",
  "if_chose_search_bills_tab_you_lose_email_filters": "Se você escolher a guia de pesquisa de faturas, você perderá os filtros de e-mail",
  "legal_name": "Nome legal",
  "nit": "NIT",
  "document_expiration_date": "Data de validade do documento",
  "operation_type": "Tipo de operação",
  "invoices_not_uploaded_this_month": "Faturas não carregadas este mês",
  "urgent": "Urgente",
  "see_actual_bill": "Ver factura real",
  "bill_already_uploaded": "Factura ya cargada",
  "bill_already_uploaded_description": "La factura ya se ha cargado a la cuenta",
  "last_invoice_uploaded": "Última fatura carregada",
  "add_hide_reminder": "Agregar ocultar recordatorio",
  "add_item": "Agregar item",
  "hide_senders": "Ocultar remetentes",
  "hide_senders_prompt": "Aquí puede ocultar correos de remitentes. Agregue la dirección de correo electrónico que desea excluir a la lista",
  "clear_filters": "Limpiar filtros",
  "stats": "Estatísticas",
  "success_message": "La lista de correos ocultos se ha actualizado",
  "review_result": "Resultado de revisión",
  "order_by": "Ordenar por",
  "review_duplicate_bill": "Revisar factura duplicada",
  "non_billing_email": "Correo no es de facturación",
  "child": "Hijo",
  "id": "ID",
  "attachments_type": "Tipo de adjuntos",
  "ticket_code": "Código de ticket",
  "add_all_the_accounts": "Agregar todas as contas",
  "add_all_the_accounts_confirm": "Se você aceitar, todas as contas que atenderem a esses filtros serão adicionadas",
  "invoice_fields": "Campos de faturas",
  "no_emails_selected": "Nenhum e-mail selecionado",
  "select_emails_to_view": "Selecione os e-mails para visualizar",
  "no_emails_data": "Nenhum dado de e-mail",
  "inactive_account": "Conta inativa",
  "daily": "Diário",
  "weekly": "Semanal",
  "monthly": "Mensal",
  "custom": "Personalizado",
  "today": "Hoje",
  "TwoDays": "Dois dias",
  "SevenDays": "Sete dias",
  "30Days": "30 dias",
  "non_existent": "Não existente",
  "status_previously_listed": "Status previamente guardado",
  "block_subject": "Assunto de bloqueio",
  "block_email": "E-mail de bloqueio",
  "add_hidden_item": "Adicionar item oculto",
  "empty_hidden_fields": "Por favor, adicione pelo menos um item oculto",
  "other_concepts": "Outros conceitos",
  "credit_note": "Nota de crédito",
  "bots_will_be_executed_for": "Bots serão executados para",
  "of_them_will_run_as_doubles": "delas serão executadas como duplas",
  "original_sender": "Remetente original",
  "time_elapsed": "Tempo decorrido",
  "clean": "Limpar",
  "visit_date": "Data de visita",
  "orden": "Ordem",
  "error_subtitle": "Ops! Ocorreu um erro",
  "error_description": "Ocorreu um erro ao carregar os dados. Por favor, tente novamente mais tarde.",
  "initial_balance": "Saldo inicial",
  "odoo_ticket_id": "ID do ticket Odoo",
  "ticket_type": "Tipo de ticket",
  "model": "Modelo",
  "company_assignment": "Atribuição de empresa",
  "company_assigned_successfully": "Empresa atribuída com sucesso",
  "success": "Sucesso",
  "accounts_petitions": "Petição de conta",
  "company_name": "Nome da empresa",
  "marketer_name": "Nome do comercializador",
  "marketer_email": "E-mail do comercializador",
  "has_bill": "Tem fatura",
  "first_send": "Primeira envio",
  "retries": "Tentativas",
  "last_attempt": "Último tentativa",
  "uploaders": "Carregadores",
  "details": "Detalhes",
  "open_extras": "Extras abertos",
  "one_month_comparation": "Comparação de um mês",
  "one_month_variation": "Variação de um mês",
  "one_month_variation_percent": "Variação de um mês (%)",
  "three_months_comparation": "Comparação de três meses",
  "three_months_variation": "Variação de três meses",
  "three_months_variation_percent": "Variação de três meses (%)",
  "six_months_comparation": "Comparação de seis meses",
  "six_months_variation": "Variação de seis meses",
  "six_months_variation_percent": "Variação de seis meses (%)",
  "annual_comparation": "Comparação anual",
  "annual_variation": "Variação anual",
  "annual_variation_percent": "Variação anual (%)",
  "alert_value_percent_max_limit_message": "O valor atual supera o {{percent}}% de variação relativa ao {{comparison}}",
  "annual_comparison": "Ano anterior",
  "one_month_comparison": "Mês anterior",
  "six_months_comparison": "6 meses atrás",
  "three_months_comparison": "3 meses atrás",
  "triggered_alerts": "Alertas disparadas",
  "details_of": "Detalhes de",
  "bill_alerts": "Alertas de faturas",
  "status_last_followup": "Status últ. acompanhamento",
  "pending": "Pendente",
  "managed": "Gerido",
  "current_value": "Valor atual",
  "seccess": "Sucesso",
  "operationSuccessful": "Operação realizada com sucesso",
  "schedule_message": "Mensagem programada",
  "schedule_message_placeholder": "Escreva sua mensagem aqui",
  "add_message": "Adicionar mensagem",
  "add_a_list_of_messages": "Para adicionar uma lista de mensagens ou uma única mensagem, clique no ícone + no canto superior direito da tela.",
  "bots_with_very_soon_execution": "Bots com execução muito próxima",
  "issue_extra_days": "Dias extras de execução",
  "tv_telephony": "TV e Telefonia",
  "user_in_charge": "Usuário responsável",
  "date_filing": "Data de expedição",
  "expiration_date": "Data de validade",
  "no_documents": "Sem documentos",
  "no_schedule": "Sem agendamento",
  "upload_excel": "Carregar excel",
  "collection_office": "Escritório de cobrança",
  "originator_nit": "NIT originador",
  "check_value": "Valor do cheque",
  "bank_movements": "Movimentos bancários",
  "upload_bank_movements": "Carregar movimentos bancários",
  "are_you_sure_to_upload_this_file": "Você tem certeza de carregar este arquivo?",
  "the_bill_will_upload_in_the_account": "A fatura será carregada na contas",
  "multiple_bill_upload": "Upload múltiplo de fatura",
  "bill_uploaded": "Fatura carregada",
  "the_bill_should_be_uploaded_from_the_main_account": "A fatura deve ser carregada da conta principal",
  "the_bill_should_be_pay_from_the_main_account": "A fatura deve ser paga da conta principal",
  "product": "Produto",
  "initial_and_final_payment_dates": "Datas de pagamento inicial e final",
  "add_new_blocked_category": "Adicionar nova categoria bloqueada",
  "blocked_categories_blacklist": "Categorias bloqueadas (Lista negra)",
  "add_new_enabled_category": "Adicionar nova categoria habilitada",
  "enabled_categories_whitelist": "Categorias habilitadas (Lista branca)",
  "category_added_successfully": "Categoria adicionada com sucesso",
  "category_removed_successfully": "Categoria removida com sucesso",
  "error_removing_category": "Erro ao remover a categoria",
  "please_enter_a_category_name": "Por favor, insira um nome de categoria",
  "this_category_already_exists_in_the_destination_list": "Esta categoria já existe na lista de destino",
  "category_moved_successfully": "Categoria movida com sucesso",
  "noOCR": "Sem OCR",
  "accountProvider": "Provedor de conta",
  "pressEnterOrComma": "Pressione Enter ou vírgula",
  "view_bank_movements": "Ver movimentos bancários",
  "configure_white_and_blacklist": "Configurar lista branca e lista negra",
  "temp_pay": "Pagamento temporário",
  "no_invoice_number": "Sem número de fatura",
  "poliza_columns": "Colunas poliza",
  "export_bills_poliza": "Exportar faturas poliza",
  "payment_blocked": "Pagamento bloqueado",
  "payment_blocked_description": "O pagamento será bloqueado pelo usuário",
  "transaction_in_verification": "Transação em verificação",
  "validate_transaction": "Validar transação",
  "remove_temp_pay": "Remover pagamento temporário",
  "range_cannot_exceed_one_month": "O intervalo não pode exceder um mês",
  "reconciliation_report": "Relatório de conciliações",
  "regional_fund_by_split": "Distribuição de Fundos grupo",
  "export_guru_errors": "Exportar erros guru",
  "edit_voucher": "Editar comprovante",
  "voucher_updated": "Comprovante atualizado",
  "edit_payment": "Editar pagamento",
  "send_automatic_reconciliation": "Enviar conciliação automática",
  "view_possible_reconciliations": "Ver possíveis conciliações",
  "forced_reconciliation": "Conciliação forçada",
  "reason": "Motivo",
  "reconciliation_with_difference": "Conciliação com diferença",
  "money_load_month": "Mês de carga de dinheiro",
  "reconciliation_between_movements": "Conciliação entre movimentos",
  "reconcile_with_itself": "Conciliar consigo mesmo",
  "id_parent": "ID pai",
  "id_meter": "ID medidor",
  "viewAll": "Ver todos",
  "export_details": "Exportar detalhes",
  "view_balance_by_groups": "Ver saldo por grupos",
  "marketer_configuration": "Configuração da comercializadora",
  "change_bot_status": "Alterar status do bot",
  "bot_status_updated": "Status do bot atualizado",
  "color_guide": "Guia de cores",
  "rollback_conciliation": "Reverter uma conciliação",
  "client_sends_invoice": "Cliente envia fatura",
  "unified_payment_config": "Modificar pagamento unificado",
  "ID": "ID",
  "unified_account": "Conta unificada",
  "block_uploading": "Carregamento bloqueado",
  "block_payment": "Pagamento bloqueado",
  "block_digitacion": "Digitação bloqueada",
  "secundary": "Secundário",
  "confirm_reconciliation": "Você tem certeza de que deseja conciliar este registro?",
  "confirm_reconcile_records": "Você tem certeza de que deseja conciliar esses registros?",
  "invoice_selection": "Seleção de faturas",
  "massive_payment": "Pagamento massivo",
  "upload_payment_file": "Carregar arquivo de pagamento",
  "has_massive_payment": "Tem pagamento massivo",
  "massive_payment_disables_individual_pay": "Não pode ser pago individualmente",
  "the_bill_should_be_deleted_from_the_main_account": "A fatura deve ser excluida da conta principal",
  "upload_pdf": "Carregar PDF",
  "consecutives": "Consecutivos",
  "failed": "Fracassado",
  "make_additional_payment": "Fazer pagamento adicional",
  "updateStateActivate": "Alterar estado para ativar",
  "updateStateDeactivate": "Alterar estado para desativar",
  "update_budget": "Atualizar orçamento",
  "forward": "Reencaminhar",
  "add_email": "Adicionar e-mail",
  "additional_payment": "Pagamento adicional",
  "balance_report": "Relatório de saldos",
  "movement_or_transfer": "Movimento ou transferência",
  "select_day": "Selecionar dia",
  "no_days_selected": "Nenhum dia selecionado",
  "monday": "Segunda-feira",
  "tuesday": "Terça-feira",
  "wednesday": "Quarta-feira",
  "thursday": "Quinta-feira",
  "friday": "Sexta-feira",
  "saturday": "Sábado",
  "sunday": "Domingo",
  "tax": "Imposto",
  "send_to_non_interacted": "Enviar para não-interagidos",
  "rolDeleteAlertDescription": "O papel foi excluído com sucesso",
  "error_delete_rol": "Erro ao excluir papel",
  "error_get_role_Id_to_delete": "Não foi possível obter o ID da função para excluir",
  "rol_Id_required_edit": "O ID da função é obrigatório para editar",
  "error_save_rol": "Erro ao salvar o papel",
  "editRolForm": "Editar Papel",
  "createRolForm": "Criar Papel",
  "rolIdIsRequiredToEdit": "O ID da função é necessário para editar",
  "validationError": "Erro de validação",
  "pleaseReviewRequiredFields": "Por favor, revise os campos obrigatórios do formulário.",
  "searchs_name": "Pesquisar por nome",
  "searchs_permissions": "Buscar por permissões",
  "error_saving_role": "Erro ao salvar o papel",
  "access_to_services": "Acessos a serviços",
  "please_select_a_company": "Por favor, selecione uma empresa",
  "error_saving": "Erro ao salvar",
  "could_not_identify_user_to_update": "Não foi possível identificar o usuário para atualizar",
  "services_modified_successfully": "Serviços modificados com sucesso",
  "user_service_accesses_have_been_updated": "Os acessos aos serviços do usuário foram atualizados",
  "error_saving_services": "Erro ao salvar serviços",
  "problem_updating_accesses_please_try_again": "Ocorreu um problema ao atualizar os acessos. Por favor, tente novamente",
  "select_a_user_to_manage_their_service_accesses": "Selecione um usuário para gerenciar seus acessos a serviços",
  "available_companies": "Empresas disponíveis",
  "save_services": "Salvar Serviços",
  "services_available_for_the_company": "Serviços disponíveis para a empresa",
  "no_services_available": "Não há serviços disponíveis",
  "loading_services": "Carregando serviços...",
  "error_loading_services": "Erro ao carregar serviços",
  "available_services": "Serviços disponíveis",
  "format": "Formato",
  "payment_agreements": "Acordos de pagamento",
  "agreements": "Acordos",
  "certificate_generated": "Certificado gerado",
  "base": "Sede",
  "please_enter_the_url": "Por favor, insira a URL!",
  "please_select_a_subtype": "Por favor, selecione um subtipo!",
  "please_select_an_acquisition_type": "Por favor, selecione um tipo de aquisição!",
  "please_enter_a_serial": "Por favor, insira um Serial!",
  "please_select_a_protocol": "Por favor, selecione um protocolo!",
  "please_enter_the_sim_number": "Por favor, insira o número do chip!",
  "please_enter_the_concentrator": "Por favor, insira o concentrador!",
  "load_profile": "Perfil de Carga",
  "please_select_a_load_profile": "Por favor, selecione um perfil de carga!",
  "modbus_with_same_database_name_already_exists": "Já existe um Modbus com o mesmo nome de banco de dados",
  "modbus_added_successfully": "Modbus adicionado com sucesso",
  "modbus_successfully_deleted": "Modbus excluído com sucesso",
  "please_enter_a_frequency_value": "Por favor, insira um valor de frequência!",
  "please_enter_an_ip_address": "Por favor, insira um endereço IP!",
  "please_select_a_frequency_unit": "Por favor, selecione uma unidade de frequência!",
  "please_enter_a_port": "Por favor, insira uma porta!",
  "please_enter_a_registration_value": "Por favor, insira um valor de registro!",
  "please_select_a_data_type": "Por favor, selecione um tipo de dado!",
  "please_select_a_unit_type": "Por favor, selecione um tipo de unidade!",
  "please_enter_a_data_length_value": "Por favor, insira um valor de comprimento de dado!",
  "please_select_a_db_name_type": "Por favor, selecione um tipo de nome DB!",
  "header_updated_successfully": "Cabeçalho atualizado com sucesso",
  "header_added_successfully": "Cabeçalho adicionado com sucesso",
  "header_deleted_successfully": "Cabeçalho excluído com sucesso",
  "sim_card": "Cartão SIM",
  "edit_header": "Editar cabeçalho",
  "add_headers": "Adicionar cabeçalhos",
  "error_deleting_meter": "Erro ao excluir o medidor",
  "meter_has_been_deleted": "O medidor foi excluído",
  "meter_has_been_successfully_deleted": "O medidor foi excluído com sucesso",
  "error_creating_meter": "Erro ao criar o medidor",
  "error_updating_meter": "Erro ao atualizar o medidor",
  "do_you_want_to_change_the_meter_status": "Deseja alterar o status do Medidor:",
  "error_changing_meter_status": "Erro ao mudar o status do medidor",
  "view_meter_details": "Ver detalhes do medidor",
  "the_file_was_generated_and_will_be_sent_to_the_email": "O arquivo foi gerado e será enviado para o e-mail:",
  "in_the_next_minutes": "nos próximos minutos.",
  "password_data_acquisition": "Senha de Aquisição de Dados",
  "generate_voucher_number": "Gerar número de voucher",
  "bill_request": "Solicitação de Fatura",
  "settings": "Configurações",
  "how_should_i_call_you_ai": "Como você quer ser chamado pela IA?",
  "extra_information_for_ia": "O que você faz, o que você normalmente faz, que informações são relevantes para você e que tom você quer que eu use?",
  "massive_provider_payments": "Pagamentos em massa do provedor",
  "paid_value_does_not_match": "O valor pago não corresponde",
  "report_change_statedigitation": "O erro foi relatado à área de digitação",
  "edit_massive_payment": "Editar pagamento em massa",
  "assing_date": "Data de atribuição",
  "significant_variation": "Variação significativa",
  "no_log_find": "Nenhuma conta foi encontrada para registrar no log",
  "manageNoveltiesBeforeUpload": "Você deve gerenciar as novidades criadas antes de poder carregar a fatura",
  "download_excel": "Baixar excel",
  "view_general_voucher": "Ver comprovante general",
  "hasTicket": "Tem ticket",
  "hasntTicket": "Não tem ticket",
  "vanti_type": "Tipo Vanti",
  "massive_payments_transfer": "Transferência de Pagamentos Massivos",
  "enter_the_value": "Insira o valor",
  "date_type": "Tipo de Data",
  "not_company": "Nenhuma empresa",
  "report_classification_problem": "Reportar problema com a classificação",
  "problem_reported_successfully": "Problema relatado com sucesso",
  "error_reporting_problem": "Erro ao relatar o problema",
  "what_is_the_classification_problem": "Qual é o problema da classificação?",
  "please_describe_classification_problem": "Por favor, descreva o problema da classificação",
  "description_min_length": "A descrição deve ter pelo menos 10 caracteres",
  "describe_classification_problem_placeholder": "Descreva o problema da classificação...",
  "generating_response": "Gerando resposta...",
  "ai_response": "Resposta IA",
  "thinking": "Resumo IA de fatura",
  "reply_email": "Responder",
  "compose": "Escrever",
  "no_body": "O corpo do e-mail é necessário para completar o envio",
  "invalid_emails": "E-mails inválidos",
  "invalid_emails_message": "Os e-mails não correspondem a um formato válido",
  "page_number": "Número da página (opcional)",
  "page_number_placeholder": "Nº da página",
  "search_offset": "Deslocamento",
  "company_type": "Tipo de empresa",
  "title_placeholder": "Insira o título...",
  "required_field": "Campo obrigatório",
  "workflow": "Fluxo de trabalho",
  "workflow_placeholder": "Selecione um fluxo de trabalho...",
  "case_priority": "Prioridade do caso",
  "low": "Baixa",
  "medium": "Media",
  "high": "Alta",
  "product_placeholder": "Selecione um produto...",
  "select_company": "Selecione uma empresa primeiro",
  "estimated_recovery": "Recuperção estimada",
  "estimated_recovery_placeholder": "Insira a recuperção estimada...",
  "category_placeholder": "Selecione uma categoria...",
  "subcategory": "Subcategoria",
  "subcategory_placeholder": "Selecione uma subcategoria...",
  "new_state": "Novo estado",
  "requestor_source": "Origem do solicitante",
  "assignment_area": "Área de encargo",
  "solution": "Solução",
  "create_case": "Criar caso",
  "ticket_created_successfully": "Ticket criado com sucesso",
  "error_creating_ticket": "Erro ao criar o ticket",
  "ticket_id": "ID do ticket",
  "ticket_already_created": "Já existe um ticket criado",
  "objective": "Objetivo",
  "main_activity": "Atividade principal",
  "hours": "Horas",
  "start": "Iniciar",
  "finish": "Finalizar",
  "specific_activity": "Atividade específica",
  "time_record": "Registro de horas",
  "worklog_created_successfully": "Registro de horas criado com sucesso",
  "error_creating_worklog": "Erro ao criar registro de horas",
  "elapsed_time": "Tempo decorrido",
  "worklog_ended_successfully": "Registro de horas finalizado com sucesso",
  "error_ending_worklog": "Erro ao finalizar registro de horas",
  "project": "Projeto",
  "no_title": "Sem título",
  "no_active_tickets": "Nenhum ticket ativo",
  "tickets": "Tickets",
  "loading": "Carregando...",
  "loading_tickets": "Carregando tickets...",
  "no_perms_for_section": "Você não tem permissão para ver esta seção",
  "loading_records": "Carregando registros...",
  "invalid_date": "Data inválida",
  "must_be_number": "Deve ser um número",
  "authorizations": "Autorizações",
  "pending_tasks": "Tarefas Pendentes",
  "create_ticket": "Criar Ticket",
  "fix_validation_errors": "Por favor corrija todos os erros de validação antes de salvar",
  "changes_saved_successfully": "Alterações salvas com sucesso",
  "save_failed_rows_detail": "Algumas linhas não puderam ser salvas. Revise os detalhes abaixo.",
  "please_try_again": "Por favor, tente novamente.",
  "incomplete": "Incompleto",
  "deletions": "Eliminações",
  "updates": "Atualizações",
  "new_authorizations": "Novas autorizações",
  "authorization_number": "Autorização #{{number}}",
  "row": "Linha",
  "column": "Coluna",
  "and_more_count": "+{{count}} a mais",
  "badge_new_rows": "linhas novas",
  "badge_updated_rows": "linhas atualizadas",
  "badge_deleted_rows": "linhas excluídas",
  "badge_unsaved_changes": "alterações não salvas",
  "badge_error_rows": "linhas com erro",
  "badge_validation_error_rows": "linhas com erros de validação",
  "badge_server_error_rows": "linhas com erros ao salvar",
  "badge_stale_rows": "linhas com conflito",
  "badge_remote_pending_rows": "alterações remotas pendentes",
  "badge_remote_new_rows": "linhas novas remotas",
  "badge_remote_delete_summary": "Esta linha foi excluída remotamente",
  "badge_remote_deleted": "Excluída remotamente",
  "badge_details_title": "Detalhes das mudanças",
  "badge_details_empty": "Não há linhas para mostrar nesta categoria.",
  "badge_details_from": "Antes",
  "badge_details_to": "Depois",
  "conflict_no_column_differences": "Nenhuma diferença de coluna encontrada.",
  "hh_hours_yesterday": "Horas ontem",
  "hh_hours_today": "Horas hoje",
  "hh_fetch_date_range": "Intervalo de datas",
  "hh_export_active_sheet": "Exportar aba ativa",
  "hh_export_requested_title": "Exportação solicitada",
  "hh_export_requested_body": "O arquivo foi baixado com os filtros atuais da aba ativa.",
  "hh_export_failed_title": "Não foi possível exportar",
  "hh_export_sheet_not_available": "Esta aba não possui exportação disponível.",
  "hh_export_wait_for_sheet": "Aguarde a aba ativa terminar de carregar antes de exportar.",
  "hh_export_no_visible_rows": "Não há linhas visíveis para exportar com os filtros atuais.",
  "hh_pending_date_planned": "Data planejada",
  "hh_pending_date_created": "Data de criação",
  "restore_rows": "Restaurar linhas",
  "hh_view_activity_guide": "Ver guia de atividades",
  "hh_activity_guide_title": "Guia de atividades",
  "resolve_conflicts": "Resolver conflitos",
  "refetch": "Recarregar",
  "verteoffice_context_invalid_selection": "Não é possível executar a ação em massa porque a seleção atual possui linhas inválidas.",
  "verteoffice_pending_tasks_open_ticket_vhelp": "Abrir Ticket no vHelp",
  "verteoffice_pending_tasks_create_ticket_vhelp": "Criar Ticket no vHelp",
  "save_blocked_errors": "Não é possível salvar: corrija os erros de validação",
  "save_blocked_conflicts": "Não é possível salvar: resolva os conflitos primeiro",
  "no_overtime_authorization": "Você não tem autorização para fazer horas extras",
  "hh_overtime_date_required_title": "Data obrigatória",
  "hh_overtime_date_required_body": "Você deve informar uma data antes de marcar este registro como hora extra.",
  "hh_overtime_hours_required_title": "Horas obrigatórias",
  "hh_overtime_hours_required_body": "Você deve informar as horas trabalhadas antes de marcar como hora extra.",
  "hh_overtime_no_authorization_title": "Sem autorização",
  "hh_overtime_no_authorization_body": "Você não tem horas extras autorizadas para a data {{date}}. Entre em contato com seu líder.",
  "hh_overtime_insufficient_title": "Horas extras insuficientes",
  "hh_overtime_insufficient_body": "Você não tem horas extras suficientes disponíveis para esta data.\n\nHoras autorizadas: {{authorized}} hrs\nHoras já usadas: {{used}} hrs\nHoras disponíveis: {{available}} hrs\nHoras necessárias: {{required}} hrs",
  "hh_validation_daily_cap_exceeded": "Excede o limite de {{cap}} horas ({{total}} hrs no total para {{date}})",
  "hh_validation_required_date": "Informe a data",
  "hh_validation_required_general_activity": "Informe a atividade geral",
  "hh_validation_required_activity_objective": "Informe o objetivo da atividade",
  "hh_validation_required_specific_activity": "Informe a atividade específica",
  "hh_validation_required_hours": "Informe as horas implementadas",
  "hh_validation_required_company": "Informe a companhia",
  "hh_validation_required_product": "Informe o produto",
  "hh_validation_required_observation": "Descreva o que você fez",
  "hh_validation_required_generic": "Informe {{field}}",
  "hh_validation_hours_not_a_number": "As horas devem ser um número",
  "hh_validation_hours_positive": "As horas devem ser maiores que zero",
  "hh_validation_hours_max_per_record": "Máximo de {{max}} horas por registro",
  "hh_validation_activity_max_hours": "Esta atividade admite no máximo {{max}} h por registro",
  "hh_validation_overtime_start_required": "Informe a hora de início da hora extra",
  "hh_validation_overtime_end_required": "Informe a hora de fim da hora extra",
  "hh_validation_select_from_list": "Selecione um valor da lista",
  "hh_validation_daily_limit_range": "O limite diário deve estar entre {{min}} e {{max}} horas",
  "hh_validation_auth_row_empty": "A autorização deve conceder algo: horas extras (acima de 0), limite diário, ou ambos",
  "hh_validation_activity_max_hours_exceeded": "A atividade {{activity}} permite no máximo {{max}} hrs em um único registro.",
  "hh_validation_auth_max_exceeded": "Excede o limite de {{max}} horas autorizadas ({{total}} hrs para {{date}})",
  "hh_validation_overtime_not_authorized": "Você não tem horas extras autorizadas para {{date}}.",
  "hh_validation_overtime_no_more_authorized": "Você não tem mais horas autorizadas para {{date}} ({{used}} hrs usadas / {{authorized}} hrs autorizadas).",
  "hh_col_general_activity": "Atividade Geral",
  "hh_col_activity_objective": "Objetivo da Atividade",
  "hh_col_specific_activity": "Atividade Específica",
  "hh_col_hours_implemented": "Horas Implementadas",
  "hh_col_overtime_start": "Hora início extra",
  "hh_col_overtime_end": "Hora fim extra",
  "hh_col_extra_time": "Tempo Extra",
  "hh_validation_overtime_window_required": "Você deve informar a hora de início e fim das horas extras.",
  "hh_validation_overtime_window_format": "A hora extra deve usar o formato HH:mm.",
  "hh_validation_overtime_window_order": "A hora fim extra deve ser maior que a hora início extra.",
  "hh_validation_overtime_window_total_mismatch": "As horas da linha não coincidem com a janela extra ({{actual}} hrs calculadas vs {{expected}} hrs registradas).",
  "hh_validation_overtime_window_disabled": "Você deve ativar a coluna de hora extra antes de editar a hora de início ou fim.",
  "hh_validation_date_not_in_future": "A data não pode ser posterior a hoje ({{today}}).",
  "hh_col_collaborator": "Colaborador",
  "hh_col_authorization_of": "Autorização de",
  "hh_col_authorization_date_short": "Aut. Data",
  "hh_col_authorized_hours": "Horas Autorizadas",
  "hh_col_authorized_date": "Data autorizada",
  "hh_col_created_date": "Data de criação",
  "hh_col_daily_limit": "Limite Diário (hrs)",
  "hh_col_activity_type": "Tipo de atividade",
  "hh_col_request_source": "Meio de solicitação",
  "hh_col_task": "Tarefa",
  "hh_col_planned_date": "Data planejada",
  "hh_col_duration": "Duração (hrs)",
  "hh_col_closing_date": "Data de Fechamento",
  "hh_pending_show_closed": "Ver fechadas",
  "hh_validation_pending_duration_required": "Para concluir a tarefa é necessário informar a duração (hrs).",
  "hh_validation_pending_product_required": "Para fechar ou cancelar a tarefa é necessário informar o produto.",
  "hh_validation_pending_responsible_required": "Para fechar ou cancelar a tarefa é necessário informar o responsável.",
  "hh_validation_pending_activity_type_required": "Para fechar ou cancelar a tarefa é necessário informar o tipo de atividade.",
  "hh_validation_pending_request_source_required": "Para fechar ou cancelar a tarefa é necessário informar o meio de solicitação.",
  "verteoffice_pending_tasks_cancel_task": "Cancelar tarefa",
  "verteoffice_pending_tasks_reschedule_task": "Reprogramar tarefa",
  "hh_evidence_modal_close_title": "Fechar tarefa",
  "hh_evidence_modal_cancel_title": "Cancelar tarefa",
  "hh_evidence_modal_reschedule_title": "Reprogramar tarefa",
  "hh_evidence_comment_label": "Comentário",
  "hh_evidence_file_label": "Arquivo anexado",
  "hh_evidence_new_planned_date_label": "Nova data planejada",
  "hh_evidence_upload_hint": "Arraste um arquivo ou clique para anexá-lo",
  "hh_evidence_upload_success": "Arquivo anexado",
  "hh_evidence_upload_error": "Não foi possível enviar o arquivo",
  "hh_evidence_required_fields": "Preencha o comentário e anexe um arquivo de evidência.",
  "hh_evidence_planned_date_required": "Selecione a nova data planejada.",
  "hh_pending_register_hours": "Registrar horas desta tarefa",
  "hh_pending_register_hours_title": "Registrar horas trabalhadas da tarefa concluída",
  "hh_col_recurring": "Recorrente",
  "hh_col_recurring_frequency": "Frequência",
  "hh_col_recurring_until": "Repete até",
  "hh_recurring_modal_title": "Tarefa recorrente",
  "hh_recurring_frequency_label": "Frequência",
  "hh_recurring_weekly": "Semanal",
  "hh_recurring_monthly": "Mensal",
  "hh_recurring_until_label": "Termina em (opcional)",
  "hh_validation_recurring_frequency": "Selecione a frequência da tarefa recorrente (SEMANAL ou MENSAL)",
  "hh_validation_recurring_planned_required": "Uma tarefa recorrente precisa de Data Planejada: a próxima repetição é calculada a partir dela",
  "hh_validation_recurring_end_invalid": "A data final da recorrência não é válida",
  "hh_validation_recurring_end_before_planned": "A data final da recorrência não pode ser anterior à data planejada",
  "hh_v2_sheet_personal": "Pessoal",
  "hh_v2_sheet_general": "Geral",
  "hh_v2_loading_step": "Passo {{current}} de {{total}}",
  "hh_v2_loading_fetching": "Buscando os registros",
  "hh_v2_loading_building": "Preparando a planilha",
  "hh_v2_loading_preparing": "Revisando as linhas",
  "hh_v2_loading_ready": "Pronto",
  "hh_v2_loading_slow": "Está demorando mais que o normal.",
  "hh_v2_loading_rows": "{{done}} de {{total}} linhas",
  "hh_v2_session_user_missing_title": "Não foi possível identificar o usuário da sessão",
  "hh_v2_session_user_missing_detail": "Entre novamente para ver seus registros de horas.",
  "hh_v2_hours_yesterday": "Horas ontem",
  "hh_v2_hours_today": "Horas hoje",
  "hh_v2_save_blocked_tooltip": "Corrija as linhas marcadas em vermelho antes de salvar",
  "hh_v2_save": "Salvar",
  "hh_v2_reload": "Recarregar dados",
  "hh_v2_activity_guide": "Guia de atividades",
  "hh_v2_export": "Exportar",
  "hh_v2_date_range_label": "Intervalo:",
  "hh_v2_sort_tag": "Ordem: {{column}} {{direction}}",
  "hh_v2_dirty_tag": "{{count}} sem salvar",
  "hh_v2_invalid_tag": "{{count}} com erros — ver detalhe",
  "hh_v2_invalid_popover_title": "Erros que impedem salvar",
  "hh_v2_issue_row": "Linha {{row}}",
  "hh_v2_stale_tag": "{{count}} desatualizadas",
  "hh_v2_all_saved": "Tudo salvo",
  "hh_v2_discard_range_detail": "Ao mudar o intervalo os dados são buscados novamente no servidor e as alterações serão descartadas.",
  "hh_v2_discard_range_ok": "Descartar e mudar o intervalo",
  "hh_v2_discard_reload_detail": "Ao recarregar, a planilha volta ao que está no servidor e as alterações serão descartadas.",
  "hh_v2_discard_reload_ok": "Descartar e recarregar",
  "hh_v2_export_requested": "Relatório solicitado",
  "hh_v2_export_failed": "Não foi possível exportar",
  "hh_v2_preview_date": "Data",
  "hh_v2_preview_activity": "Atividade",
  "hh_v2_preview_specific": "Específica",
  "hh_v2_preview_hours": "Horas",
  "hh_v2_preview_company": "Empresa",
  "hh_v2_preview_product": "Produto",
  "hh_v2_confirm_title": "Confirmar gravação",
  "hh_v2_confirm_ok": "Salvar",
  "hh_v2_confirm_cancel": "Voltar à planilha",
  "hh_v2_confirm_nothing": "Não há nada pendente para salvar.",
  "hh_v2_confirm_summary_one": "Será salvo {{parts}}.",
  "hh_v2_confirm_summary_other": "Serão salvos {{parts}}.",
  "hh_v2_section_create": "Linhas novas",
  "hh_v2_section_create_empty": "Não há linhas novas",
  "hh_v2_section_update": "Linhas editadas",
  "hh_v2_section_update_empty": "Não há linhas editadas",
  "hh_v2_section_delete": "Linhas excluídas",
  "hh_v2_section_delete_empty": "Não há linhas excluídas",
  "hh_v2_section_discard": "Linhas novas que serão descartadas",
  "hh_v2_column_row": "Linha",
  "hh_v2_column_changed_keys": "Colunas modificadas",
  "hh_v2_boolean_yes": "Sim",
  "hh_v2_boolean_no": "Não",
  "hh_v2_count_created_one": "{{count}} inclusão",
  "hh_v2_count_created_other": "{{count}} inclusões",
  "hh_v2_count_updated_one": "{{count}} alteração",
  "hh_v2_count_updated_other": "{{count}} alterações",
  "hh_v2_count_deleted_one": "{{count}} exclusão",
  "hh_v2_count_deleted_other": "{{count}} exclusões",
  "hh_v2_count_discarded_one": "{{count}} linha que será descartada",
  "hh_v2_count_discarded_other": "{{count}} linhas que serão descartadas",
  "hh_v2_list_and": "e",
  "hh_v2_result_ok": "Entendi",
  "hh_v2_result_title_success": "Alterações salvas",
  "hh_v2_result_title_partial": "Foi salva apenas uma parte",
  "hh_v2_result_nothing": "Nenhuma linha foi salva.",
  "hh_v2_result_summary_one": "Foi salvo {{parts}}.",
  "hh_v2_result_summary_other": "Foram salvos {{parts}}.",
  "hh_v2_result_failures_one": "{{count}} linha não pôde ser salva:",
  "hh_v2_result_failures_other": "{{count}} linhas não puderam ser salvas:",
  "hh_v2_result_conflict": "Outro usuário modificou esta linha; recarregue para ver a versão dele.",
  "hh_v2_guide_title": "Guia de atividades",
  "hh_v2_guide_intro": "Hierarquia completa das atividades disponíveis para a sua área. Escolha de cima para baixo: a Atividade Geral determina os objetivos, e o Objetivo determina as atividades específicas.",
  "hh_v2_guide_level_general": "Geral",
  "hh_v2_guide_level_objective": "Objetivo",
  "hh_v2_guide_level_specific": "Específica",
  "hh_v2_guide_search_placeholder": "Buscar nos três níveis…",
  "hh_v2_guide_expand_all": "Expandir tudo",
  "hh_v2_guide_collapse_all": "Recolher tudo",
  "hh_v2_guide_empty": "Não há atividades disponíveis",
  "hh_v2_guide_no_matches": "Sem correspondências",
  "hh_v2_missing_days": "Dias pendentes",
  "hh_v2_missing_tooltip": "Dias da janela de fechamento em que faltam horas",
  "hh_v2_missing_title": "Dias pendentes de registro",
  "hh_v2_missing_window": "Janela: {{from}} — {{to}}",
  "hh_v2_missing_days_count_one": "{{count}} dia pendente",
  "hh_v2_missing_days_count_other": "{{count}} dias pendentes",
  "hh_v2_missing_day_tag": "Faltam {{hours}} h",
  "hh_v2_missing_day_hours": "{{hours}} h registradas",
  "hh_v2_missing_day_empty": "Sem nenhum registro",
  "hh_v2_missing_none_title": "Você está em dia",
  "hh_v2_missing_none_detail": "Não há dias pendentes na janela de fechamento.",
  "hh_v2_missing_error_title": "Não foi possível consultar os dias pendentes",
  "hh_v2_missing_refresh": "Atualizar",
  "hh_v2_unsaved_title": "Há alterações sem salvar",
  "hh_v2_unsaved_changes_one": "Há {{count}} linha com alterações sem salvar.",
  "hh_v2_unsaved_changes_other": "Há {{count}} linhas com alterações sem salvar.",
  "hh_v2_unsaved_leave_warning": "Se você sair da tela elas serão perdidas.",
  "hh_v2_unsaved_advice_blocked": "Fique para corrigir as linhas em vermelho e poder salvá-las.",
  "hh_v2_unsaved_advice": "Fique e clique em Salvar para conservá-las.",
  "hh_v2_unsaved_leave_ok": "Sair sem salvar",
  "hh_v2_unsaved_stay": "Ficar aqui",
  "hh_v2_cancel": "Cancelar",
  "number_between_0_and_2": "Digite um número maior que 0 e menor que 2",
  "enter_true_or_false": "Por favor insira TRUE ou FALSE",
  "select_valid_user": "Você deve selecionar um Colaborador válido da lista",
  "select_valid_authorizer": "Você deve selecionar um Autorizador válido da lista",
  "select_valid_company": "Você deve selecionar uma Empresa válida da lista",
  "select_valid_product": "Você deve selecionar um Produto válido da lista",
  "select_valid_project": "Você deve selecionar um Projeto válido da lista",
  "select_valid_general_activity": "Você deve selecionar uma Atividade Geral válida da lista",
  "select_valid_specific_activity": "Você deve selecionar um Objetivo da Atividade válido da lista",
  "select_valid_activity_objective": "Você deve selecionar uma Atividade Específica válida da lista",
  "select_valid_activity_type": "Você deve selecionar um Tipo de Atividade válido da lista",
  "select_valid_request_source": "Você deve selecionar uma Origem da Solicitação válida da lista",
  "select_valid_status": "Você deve selecionar um Status válido da lista",
  "working_hours_of": "Horas de trabalho de",
  "no_changes": "Sem alterações",
  "no_changes_to_save": "Não há alterações para salvar",
  "no_options_configured_for": "Não há opções configuradas para: ",
  "view_seed_execution_details": "Ver detalhes de execução de sementes",
  "seed_execution_details": "Detalhes de execução de sementes",
  "executed_at": "Executado em",
  "finished_at": "Finalizado em",
  "updated_at_date": "Data de atualização",
  "reviewLogs": "Registros de Revisão",
  "exportall": "Exportar todo o faturamento",
  "seed_execution_list": "Lista de execução de sementes",
  "not_executed": "Não executado",
  "temp_pay_detected": "Pagamento temporário detectado",
  "replace_bill": "Substituir fatura",
  "upload_new_bill": "Carregar nova fatura",
  "temp_pay_account_warning": "Esta conta tem uma fatura registrada como pagamento temporário para este mês.",
  "bill_already_uploaded_account_warning": "Esta conta já possui uma fatura carregada para este mês.",
  "automatic_upload_replace_hint": "Ao pressionar \"{{button}}\" será perguntado se deseja substituí-la ou carregar uma nova fatura para este período.",
  "replace_or_new_bill_question": "Já existe uma fatura carregada para esta conta neste período. Deseja substituí-la ou carregar uma nova?",
  "successful_seeds_execution": "E. sementes bem-sucedidas",
  "save_changes": "Salvar alterações",
  "reload_data": "Recarregar dados",
  "number_between_0_and_24": "Digite um número entre 0 e 24",
  "must_select_valid_option": "Você deve selecionar uma opção válida da lista",
  "select_valid_option_for": "Você deve selecionar uma opção válida para {{field}}",
  "validation_errors_found": "Erros de validação encontrados",
  "record_number": "Registro #{{number}}",
  "required_fields_missing": "Campos obrigatórios faltando",
  "invalid_values": "Valores inválidos",
  "validation_error": "Erro de validação",
  "not_found": "Não encontrado",
  "could_not_create_all_rows": "Não foi possível criar todas as linhas ({{created}}/{{total}})",
  "no_valid_changes_to_save": "Não há alterações válidas para salvar",
  "no_response": "Sem resposta",
  "error_deleting": "Erro ao excluir",
  "saving_changes": "Salvando alterações...",
  "please_wait": "Por favor aguarde enquanto as alterações são processadas",
  "confirm_save": "Confirmar salvamento",
  "total_changes": "Total de alterações",
  "new_records": "Novos registros",
  "verteoffice_loading_data": "Carregando dados...",
  "verteoffice_loading_sheet": "Carregando planilha...",
  "verteoffice_preparing_engine": "Preparando motor...",
  "verteoffice_setting_events": "Configurando eventos...",
  "verteoffice_applying_validations": "Aplicando validações...",
  "verteoffice_switching_sheet": "Trocando planilha...",
  "verteoffice_hydrating_grid": "Sincronizando grade...",
  "verteoffice_finalizing": "Finalizando...",
  "verteoffice_ready": "Pronto",
  "verteoffice_load_timeout": "Erro ao carregar. Recarregue a página.",
  "verteoffice_sync_timeout": "Não foi possível sincronizar a planilha ativa. Tente recarregar.",
  "verteoffice_phase_progress": "Passo {{current}} de {{total}}",
  "validation_invalid_number": "Deve ser um número válido",
  "validation_invalid_number_range": "Deve ser um número entre {{min}} e {{max}}",
  "validation_invalid_date": "Deve ser uma data válida",
  "validation_invalid_boolean": "Deve ser verdadeiro ou falso",
  "validation_invalid_format": "Formato inválido",
  "validation_invalid_value": "Valor inválido",
  "validation_invalid_ticket_id": "Deve ser um ID numérico ou um link válido",
  "select": "Selecionar",
  "download_all_billing": "Baixar todo o faturamento",
  "pending_approved_payment": "Excluir pagos",
  "new_revision": "Nova revisão",
  "bill_placeholder": "Buscar fatura",
  "file_not_found": "Arquivo não encontrado",
  "select_a_year": "Selecione um ano",
  "no_invoices_available_for_year": "Não há faturas disponíveis para o ano",
  "new_activity": "Agregar nova atividade",
  "finished_activity": "Agregar atividade finalizada",
  "invalid_credentials": "Credenciais inválidas",
  "alerts_read_only": "Esta visualização é somente leitura",
  "verteoffice_context_no_actions_available": "Não se aplica a esta seleção",
  "meterNameAcrel": "Nome medidor Acrel",
  "mqttTopico": "Tópico MQTT",
  "nickname": "Nickname",
  "names": "Nomes",
  "lastnames": "Sobrenomes",
  "telephone": "Telefone",
  "roles_aplication": "Funções da aplicação",
  "add_bill_to_existing": "Adicionar fatura à existente",
  "add_bill_to_existing_subtitle": "Faça upload de uma nova imagem que será unida à fatura atual",
  "add_bill_to_existing_related_description": "A nova imagem também será adicionada às contas relacionadas",
  "add_bill_button": "Adicionar fatura",
  "file_not_uploaded_yet": "O arquivo ainda não terminou de ser enviado",
  "bill_added_successfully": "Fatura adicionada com sucesso",
  "facturas": "Contas Pendentes Digitação",
  "pending_bills_digitation": "Contas Pendentes Digitação",
  "read_only_sheet": "Esta planilha é somente leitura",
  "assign_responsable": "Atribuir Digitador",
  "assign_responsable_bulk": "Atribuição em Massa de Digitador",
  "responsable": "Digitador",
  "select_responsable": "Selecionar digitador",
  "payment_notifications_massive_pay_transfer": "Pagamento em massa por transferência",
  "payment_notifications_massive_pay_provider": "Pagamento em massa por prestador",
  "payment_notifications_massive_pay_filter_required": "Aplique um filtro em Pagamentos Abertos para habilitar esta ação",
  "payment_notifications_massive_pay_row_count_required": "O filtro deve deixar entre 2 e 300 faturas visíveis",
  "payment_notifications_massive_pay_validating": "Validando as faturas visíveis...",
  "payment_notifications_massive_pay_common_invalid": "As faturas visíveis não atendem aos requisitos gerais do pagamento em massa",
  "payment_notifications_massive_pay_transfer_invalid": "As faturas visíveis não atendem aos requisitos do pagamento em massa por transferência",
  "payment_notifications_massive_pay_provider_invalid": "As faturas visíveis não atendem aos requisitos do pagamento em massa por prestador",
  "payment_notifications_massive_pay_preflight_error": "Não foi possível validar as faturas visíveis",
  "massive_pay_visible_row_count_detail": "Há {{count}} faturas visíveis. O filtro deve deixar entre 2 e 300.",
  "wait_for_current_bill_loading": "Aguarde o carregamento da fatura atual.",
  "massive_pay_bill_not_pending": "{{bill}} não está PENDENTE (estado: {{status}}).",
  "massive_pay_child_account": "{{bill}} é uma conta filha. Apenas contas pai ou independentes são permitidas.",
  "massive_pay_bill_already_assigned": "{{bill}} já possui um pagamento em massa.",
  "massive_pay_selection_already_assigned": "Pelo menos uma fatura visível já possui um pagamento em massa.",
  "massive_pay_cash_source_mismatch": "As faturas visíveis não possuem a mesma origem de recursos.",
  "massive_pay_company_family_mismatch": "As faturas visíveis não pertencem à mesma empresa ou família de empresas.",
  "massive_pay_missing_transfer_method": "{{bill}}: o prestador não possui TRANSFERENCIA ELECTRONICA como método de pagamento de prioridade 1.",
  "massive_pay_transfer_methods_lookup_failed": "Não foi possível validar os métodos de pagamento dos prestadores.",
  "massive_pay_marketer_mismatch": "As faturas visíveis não pertencem ao mesmo prestador.",
  "massive_pay_unsupported_marketer": "O prestador selecionado não está habilitado para pagamentos em massa por prestador.",
  "massive_pay_digitization_required": "Todas as faturas visíveis devem estar digitadas ou possuir um total reconhecido por OCR."
}
